<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area esg01">
      <img
        :src="`${resources}img/img-top-sub-title12.jpg`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">윤리경영</div>
        <div class="sub_txt">
          순리에 벗어나지 않은<br v-if="device === 'mo'" />
          바른 윤리 경영을 추구합니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents" v-if="device === 'mo'">
      <div class="inner">
        <dl class="ethical_tit">
          <dt><em>윤리경영</em>이란</dt>
          <dd>
            기업의 경제적 · 법적 책임 수행은 물론 사회적 통념에 요구되는 윤리적
            책임을 기본 의무로 인정하고 기업윤리 준수를 기업 경영활동에 반영하는
            것을 의미합니다. 한국오션플랫폼은 윤리적 기업문화가 정착하도록
            여러분의 소중한 의견에 귀 기울이고 있습니다.
          </dd>
        </dl>
        <ul class="ethical_con">
          <li>
            <img :src="`${resources}img/img_ethical01.jpg`" alt="" />
            <div class="ethical_inner">
              <strong>비리행위 신고</strong>
              <p>임직원의 금품, 향응을 수수하는 행위 등 비리사실에 대한 신고</p>
            </div>
          </li>
          <li>
            <img :src="`${resources}img/img_ethical02.jpg`" alt="" />
            <div class="ethical_inner">
              <strong>갑질행위 신고</strong>
              <p>임직원에게 겪은 폭언, 폭행 행위에 대한 신고</p>
            </div>
          </li>
          <li>
            <img :src="`${resources}img/img_ethical03.jpg`" alt="" />
            <div class="ethical_inner">
              <strong>직장 내 괴롭힘 &middot; 성희롱 신고</strong>
              <p>직장 내 괴롭힘이나 성희롱을 당한 경우 신고</p>
            </div>
          </li>
        </ul>
        <div class="btn_cnt_wrap">
          <a
            href="//ethics.lsholdings.co.kr/m/ko/view/report.asp?cn=013000"
            target="_blank"
            rel="noreferrer noopener"
            class="btn_link02"
            >사이버 신문고에 제보하기</a
          >
        </div>
      </div>
      <div
        class="inner"
        v-toggle="{
          target: 'tabItemRef',
          selector: '.tab_esg .tab_item a',
          onTag: 'a',
          onClass: 'actvie',
          dataType: Boolean,
        }"
        @onChange="changeTab"
        ref="tabItemRef"
      >
        <h4>윤리규범</h4>
        <p class="txt">
          한국오션플랫폼의 임직원이라면 누구나 지키고 발전시켜 나가야 할 윤리적
          가치와 행동 기준입니다.
        </p>
        <div class="tab_esg">
          <div class="tab_item">
            <a href="#" :class="{ active: tabActs[0] }">윤리규범</a>
            <a href="#" :class="{ active: tabActs[1] }">실천지침</a>
          </div>
        </div>
        <ul class="conbox_wrap">
          <!-- 윤리규범 -->
          <li :class="{ active: tabActs[0] }">
            <div class="tab_inner charter_txt">
              <div>
                <p class="profess">
                  (전문)<br />
                  <br />한국오션플랫폼㈜는 경영철학의 근간인 윤리성(Integrity)
                  바탕으로 한국오션플랫폼㈜ 모든 임직원이 지켜야 할 바른 행동과
                  가치판단의 기준으로써 ‘한국오션플랫폼㈜ 윤리규범 및 실천
                  지침’을 정비하고 적극적인 실천과 지속적인 발전을 추구해
                  나간다.
                </p>

                <!--depth01-->
                <ol class="depth_01">
                  <li>
                    <h4>제 1 장 고객에 대한 책임과 의무</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 고객의 존중</h5>
                        <ol class="depth_03">
                          <li>
                            1) 고객의 의견을 경청하고 존중하며 고객의 요구는
                            항상 옳다고 생각한다.
                          </li>
                          <li>
                            2) 고객만족을 모든 판단 및 행동에 있어 최우선
                            기준으로 삼는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>2. 진실한 정보 제공</h5>
                        <ol class="depth_03">
                          <li>
                            1) 고객에게 진실한 정보만을 전하며, 허위 사실을
                            유포하거나 허위 정보를 제공하지 않는다.
                          </li>
                          <li>
                            2) 고객이 마땅히 알아야 할 정보를 감추지 않으며,
                            경쟁사의 제품을 비방하거나 근거 없는 비교를 하지
                            않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>3. 고객에 대한 응대</h5>
                        <ol class="depth_03">
                          <li>1) 고객과의 약속은 반드시 지킨다.</li>
                          <li>
                            2) 고객으로부터 정당한 교환요청이나 반품 요구가 있는
                            경우 신속하게 응답한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>4. 고객에 대한 가치 제공</h5>
                        <ol class="depth_03">
                          <li>
                            1) 윤리성과 주인의식을 가지고 상호 존중과 배려,
                            신뢰를 통해 고객에게 참되고 실질적인 가치를 제공할
                            수 있도록 노력한다.
                          </li>
                          <li>
                            2) 고객의 요구에 맞는 제품과 서비스를 합리적인
                            가격으로 제공하며, 고객의 정당한 요구에는 신속하고
                            정확하게 대응한다.
                          </li>
                          <li>
                            3) 품질 신뢰성 및 안정성에 대한 고객의 기대와
                            요구사항을 충족하는 제품을 공급하기 위해 품질관리를
                            철저하게 한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>5. 고객의 이익 보호</h5>
                        <ol class="depth_03">
                          <li>
                            1) 고객의 재산을 내 것처럼 보호하고 임의로 사용하지
                            않는다.
                          </li>
                          <li>
                            2) 고객의 정보를 취득한 경우 무단 사용하거나
                            누설하지 않는다.
                          </li>
                          <li>
                            3) 고객의 이익과 안전을 침해하는 비도덕적 행위를
                            하지 않는다.
                          </li>
                        </ol>
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                  <li>
                    <h4>제 2 장 공정한 경쟁(경쟁사)</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 정당한 정보의 입수 및 활용</h5>
                        <ol class="depth_03">
                          <li>
                            1) 부당한 방법으로 경쟁사의 정보나 영업비밀을
                            취득하지 않는다.
                          </li>
                          <li>
                            2) 정당하게 입수된 경쟁사의 정보라도 부당하게 외부
                            누설 않는다.
                          </li>
                          <li>
                            3) 입수된 정보는 소비자 및 경쟁사에 피해를 주지
                            않도록 정당하게 활용한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>2. 정당한 경쟁우위 확보</h5>
                        <ol class="depth_03">
                          <li>
                            1) 경쟁사가 보유한 모든 분야의 유. 무형자산을
                            도용하거나 무단으로 침해하지 않는다.
                          </li>
                          <li>
                            2) 경쟁사에 대한 경쟁우위 확보를 위해 광고 등으로
                            상대방을 비방 하거나 근거 없는 상호 비교를 하지
                            않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>3. 부당한 담합금지</h5>
                        <ol class="depth_03">
                          <li>
                            1) 경쟁사와 판매가격, 판매조건 및 지역배분 등에 대해
                            담합하여 고객에게 피해를 주지 않는다.
                          </li>
                          <li>
                            2) 동종 거래처들과 부당한 협의체 또는 담합기구를
                            구성하거나 가입하지 않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>4. 법규 및 상관습의 존중</h5>
                        <ol class="depth_03">
                          <li>
                            1) 국내 및 해외에서의 모든 사업활동은 해당 국가의
                            제반 법규를 준수하고 상거래 관습을 존중한다.
                          </li>
                          <li>
                            2) 국제개발기구(OECD)의 ‘국제 상거래 뇌물방지 협약’
                            과 한국법의 ‘국제 상거래 뇌물 방지법’을 준수한다.
                          </li>
                        </ol>
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                  <li>
                    <h4>제 3 장 공정한 거래(협력업체)</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 공정한 절차에 의한 거래처 선정</h5>
                        <ol class="depth_03">
                          <li>
                            1) 거래처를 공정한 평가기준으로 선정, 등록할 수 있게
                            ‘거래처 선정절차에 관한 제반 규정과 제도’를 정립하고
                            실행한다.
                          </li>
                          <li>
                            2) 거래처 선정절차는 사업별 특성을 고려하여 구체적인
                            평가항목과 평가방법을 선정한다.
                          </li>
                          <li>
                            3) 거래처를 선정하는데 있어 혈연, 지연, 학연 등
                            사사로운 이해관계나 압력, 청탁 등을 배제한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>2. 공정한 거래와 평가</h5>
                        <ol class="depth_03">
                          <li>
                            1) 협력업체와 partnership을 통해 상생협력과
                            동반성장을 실현한다.
                          </li>
                          <li>
                            2) 거래에 필요한 정보는 적절한 때에 서로 제공하며,
                            정보의 외부 노출로 인한 피해가 없도록 사전에 필요한
                            보안조치를 한다.
                          </li>
                          <li>
                            3) 공정한 기준에 따라 정기적으로 평가하며, 평가된
                            거래결과를 거래처에 통보하고 다음 거래에 반영한다.
                          </li>
                          <li>
                            4) 거래의 개선을 위해 제시된 건전한 의견은 업무에
                            반영한다.
                          </li>
                          <li>
                            5) 거래처의 기술이나 기타 자산을 사용할 경우 반드시
                            거래처의 승인을 받는다.
                          </li>
                          <li>
                            6) 회사가 명백히 잘못하여 거래처가 피해를 입는 경우
                            공정하게 배상한다.
                          </li>
                          <li>
                            7) 기타 공정거래 관련 법규에서 금지하고 있는
                            불공정한 행위를 하지 않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>3. 깨끗하고 투명한 거래질서 유지</h5>
                        <ol class="depth_03">
                          <li>
                            1) 거래처로부터 금품, 용역, 향응, 기타 편의 등
                            경제적인 이익을 제공 받거나 요구하지 않는다.
                          </li>
                          <li>
                            2) 거래와 관련하여 혈연, 지연, 학연 등 특수관계에
                            의한 청탁이나 업무상의 지위를 이용하여 외부 압력을
                            행사하지 않는다.
                          </li>
                          <li>
                            3) 거래 과정에서 알게 된 협력업체의 정보 및 기술을
                            사전 승인 없이 이용함으로써 협력업체의 사업활동을
                            방해하지 않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>4. 협력업체의 지원</h5>
                        <ol class="depth_03">
                          <li>
                            1) 협력업체의 실질적인 육성을 위해 협력업체 육성
                            지침을 제정하고 이를 준수한다.
                          </li>
                          <li>
                            2) 상기 지침은 협력업체의 자격, 권리, 의무를
                            명시하고 기술지원 및 경영지도 등 실질적 육성을 위한
                            운영기준을 포함한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>
                          5. 부당한 행위 금지<br />협력업체 및 이해관계자와의
                          거래에 있어 다음과 같은 부당한 행위를 하지 않는다.
                        </h5>
                        <ol class="depth_03">
                          <li>
                            1) 상품 또는 서비스를 제공하면서 부당하게 다른 상품
                            또는 제품의 구매를 강요하는 행위
                          </li>
                          <li>
                            2) 거래처와 경쟁사와의 거래를 부당하게 금지하거나,
                            거래지역 또는 거래상대를 부당하게 제한하는 행위
                          </li>
                          <li>
                            3) 거래처와 협의 없이 일방적으로 판매가격을
                            인상하거나, 구매가격을 인하하는 등의 부당한 가격
                            결정 행위
                          </li>
                          <li>
                            4) 거래처의 정당한 반품 요구를 거절하거나, 주문한
                            물품의 수령거부, 지연 및 부당하게 검사에서 불합격
                            처리하는 행위
                          </li>
                          <li>
                            5) 대금 결제조건에 대한 법적 의무를 이행하지 않는
                            행위
                          </li>
                          <li>
                            6) 특정 거래처를 차별하여 거래가격, 거래조건,
                            거래내용을 부당하게 대우하는 행위
                          </li>
                          <li>
                            7) 거래처와 서로 합의한 계약상 의무사항을 일방적으로
                            변경 또는 폐기하는 행위
                          </li>
                          <li>
                            8) 기타 공정거래에 관한 관계 법규에서 금지하고 있는
                            불공정 거래 행위
                          </li>
                        </ol>
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                  <li>
                    <h4>제 4 장 임직원의 기본윤리</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 한국오션플랫폼㈜ 임직원으로서 품위 유지</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사의 명예와 개인의 품위 유지를 훼손시킬 수 있는
                            비도덕적이고 비윤리적인 행위를 하지 않는다.
                          </li>
                          <li>
                            2) 직장 내에서 필요한 기본적인 예의를 지키며, 각자의
                            사생활을 존중한다.
                          </li>
                          <li>
                            3) 각종 루머, 유언비어 조성 및 유포 등 조직 내
                            불신풍조를 조장하는 행위를 하지 않는다.
                          </li>
                          <li>
                            4) 조직관리에 있어 폭언, 인격비하 발언 등을 통해
                            사기를 저하시키고 조직문화를 해치는 사해(社害)행위를
                            하지 않는다.
                          </li>
                          <li>
                            5) 학벌, 성별, 종교, 혈연, 출신지역, 연령, 장애,
                            결혼여부, 국적, 인종 등에 따른 파벌이나 사조직을
                            결성하지 않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>2. 회사재산 및 중요 정보의 보호</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사재산에 손실을 가져올 중요하고 긴급한 사태가
                            발생하거나 발생 가능성이 있는 경우 즉시 보고를 하고
                            조치를 취한다.
                          </li>
                          <li>
                            2) 회사의 물적재산, 지적재산권, 영업비밀 등은
                            철저하게 보호해야 하며 개인적인 목적을 위해 부당하게
                            사용하지 않는다.
                          </li>
                          <li>
                            3) 직위를 이용한 사적 이익 추구, 회사에서 얻은
                            비공개 정보를 이용한 불공정한 거래행위를 하지
                            않는다.
                          </li>
                          <li>
                            4) 회사의 기밀정보는 관련 규정에 의거 보안을
                            유지하며, 회사 정보의 대외 공개는 사전에 회사의
                            승인을 받는다.
                          </li>
                          <li>
                            5) 소셜 네트워크(페이스북, 블로그, 카페 등)나
                            인터넷을 통해 회사의 중요 문서나 정보를 부당하게
                            유출하거나 사용하지 않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>3. 공정한 직무수행</h5>
                        <ol class="depth_03">
                          <li>
                            1) 공정한 직무수행을 위해 다음과 같은 행위를 하지
                            않는다.
                            <ul class="dash_sty">
                              <li>이해관계자로부터 사례를 받는 행위</li>
                              <li>
                                이해관계자와의 공동투자, 공동재산취득, 금전대차
                                행위
                              </li>
                              <li>회사 자산을 불법으로 사용하는 행위</li>
                              <li>직무태만, 관리감독 소홀, 월권 행위</li>
                              <li>
                                직무를 이용하여 개인적 이익을 도모하는 행위
                              </li>
                              <li>문서 또는 계수를 조작하는 행위</li>
                              <li>직무와 관련이 없는 부당한 업무지시 행위</li>
                            </ul>
                          </li>
                          <li>
                            2) 업무와 이해관계가 있는 사람으로부터 사례를
                            제공받지 않으며, 부득이하게 사례를 받은 경우 회사에
                            신고한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>4. 정직하고 공정한 보고</h5>
                        <ol class="depth_03">
                          <li>
                            1) 사실과 다르게 문서 계수를 조작하거나 허위보고
                            함으로써 상위자 및 관련부서의 의사결정을 오도하지
                            않는다.
                          </li>
                          <li>
                            2) 모든 거래는 회계의 근간인 신뢰성과 객관성의
                            원칙에 의해 장부 등에 기록한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>5. 직위·직무를 이용한 부당한 행위 금지</h5>
                        <ol class="depth_03">
                          <li>
                            1) 재직 중에 직무상 이해관계자로부터 퇴직 후
                            피고용을 약속 받거나 이를 요구하지 않는다.
                          </li>
                          <li>
                            2) 직무상 이해관계자와 개인적인 사업상 계약을
                            체결하거나 자산임차, 금전대차 등의 거래를 하지
                            않는다.
                          </li>
                          <li>
                            3) 상위자는 그 조직 또는 하위자에게 개인적인 용무
                            등을 시키거나 묵시적으로 요구하지 않는다.
                          </li>
                          <li>
                            4) 상사는 부하직원에게 법규 및 사규에 맞지 않는
                            업무지시를 할 수 없으며, 상사로부터 법규 및 사규에
                            맞지 않는 지시를 받은 직원은 업무 수행을 거부할 수
                            있고, 그런 내용을 회사에 알린 경우에도 불이익을 받지
                            않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>6. 회사와의 이해상충 회피</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사와 이해가 상충될 가능성이 있는 외부업체를
                            직접 경영하거나 출자하지 않는다.
                          </li>
                          <li>
                            2) 회사와 경쟁관계에 있는 업체에 이중으로 공용되거나
                            회사의 이익과 상충되는 상담, 조언 등을 제공하지
                            않는다.
                          </li>
                          <li>
                            3) 타 회사에 고용되거나 타 회사에서 현 직무와 유사한
                            일을 수행하는 경우 그 사실을 반드시 사전 승인
                            받는다.
                          </li>
                          <li>
                            4) 내부 정보를 이용하여 본인이 회사 주식을
                            매개하거나 타인에게 회사 주식의 거래를 권유하지
                            않는다.
                          </li>
                          <li>
                            5) 가족이나 친지가 경영하는 업체를 거래회사로
                            선정하거나 거래하도록 영향력을 행사하지 않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>7. 직장내 성희롱 방지</h5>
                        <ol class="depth_03">
                          <li>
                            1) 직장 내에서 성적 유혹이나 성적 수치심을
                            유발시키는 농담, 신체적 접근으로 개인의 인권을
                            침해하고 근무 의욕을 감소시키는 행위를 하지 않는다.
                          </li>
                          <li>
                            2) 자신의 언행이 다른 사람에게 정신적, 육체적 피해를
                            줄 수 있다는 점을 유념하여 항상 조심한다.
                          </li>
                          <li>
                            3) 지위 고하를 불문하고 회사 내에서 성희롱으로 인해
                            회사 생활에 지장이 생기거나 인격이 침해되는 일이
                            없도록 한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>8. 정치활동 금지</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사는 개인의 참정권과 정치 의사를 존중하되,
                            임직원의 신분으로 정치에 개입하지 않아야 한다.
                          </li>
                          <li>
                            2) 정치단체, 정당 또는 후보자에게 불법적인
                            기부금이나 자금을 제공하지 않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>9. 윤리규범 준수</h5>
                        <ol class="depth_03">
                          <li>
                            1) 윤리규범을 성실하게 준수해야 하며, 위반한
                            경우에는 해당 행위에 대한 책임을 진다.
                          </li>
                          <li>
                            2) 윤리규범에 반하는 행위를 강요 받거나 부당한
                            행위를 인지한 경우에는 윤리경영 담당부서인
                            한국오션플랫폼㈜ 인사총무팀에 신고를 한다.
                          </li>
                        </ol>
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                  <li>
                    <h4>제 5 장 회사의 임직원에 대한 책임</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 인재의 육성</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사는 임직원을 자율적이고, 창의적인 인재로
                            육성할 수 있도록 필요한 제도를 갖추고 이를 지원하며
                            활성화 시킨다.
                          </li>
                          <li>
                            2) 상사는 부하를 도전적이고 강인한 인재로
                            육성하겠다는 의지로, 적성과 소질을 고려하여 필요한
                            충고와 지도를 한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>2. 능력과 업적에 대한 대우</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사는 임직원의 능력 향상을 위한 기회(교육,
                            직무이동, 진급, 보직결정 등)를 학벌, 성별, 종교,
                            출신지역, 연령, 장애, 결혼여부, 국적, 인종 등에 따라
                            차등을 두지 않는다.
                          </li>
                          <li>
                            2) 회사는 능력과 업적에 대한 명확한 평가기준을 정립
                            및 공개하고 엄격히 준수함으로써 공정한 경쟁 풍토를
                            조성한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>3. 건전한 의사표시의 보장</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사는 임직원이 자유롭게 제안, 건의 및 애로사항을
                            표시할 수 있도록 필요한 제도를 갖추고 분위기를
                            조성한다.
                          </li>
                          <li>
                            2) 특정 종교나 정당을 위한 활동을 권유하거나
                            강요하지 않으며, 개인의 종교, 정치적 의사를
                            존중한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>4. 건강과 안전에 대한 책임</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사는 임직원의 건강과 업무 수행상의 안전을
                            위하여 필요하고도 적절한 조치를 취한다.
                          </li>
                          <li>
                            2) 특히 위험물, 유해물, 위해요인이 있는 작업장의
                            경우 반드시 필요한 안전조치를 취한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>5. 임직원의 삶의 질 향상</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사는 임직원이 자율적이고 창의적으로 일할 수
                            있도록 근무환경을 조성한다.
                          </li>
                          <li>
                            2) 회사는 모든 임직원들에게 자기개발과 역량향상을
                            위한 제반 활동을 적극 지원한다.
                          </li>
                        </ol>
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                  <li>
                    <h4>제 6 장 국가와 사회에 대한 책임</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 합리적인 사업 전개</h5>
                        <ol class="depth_03">
                          <li>
                            1) 회사는 사회의 윤리적 가치관을 존중하여 국민경제에
                            해를 끼치거나 위화감을 조성하는 행위를 하지 않으며
                            국민정서에 부합하는 사업을 전개한다.
                          </li>
                          <li>
                            2) 국내외를 막론하고 해당 지역의 사회적 가치관을
                            존중하며 사업을 수행한다.
                          </li>
                          <li>
                            3) 올바르고 합리적인 기업활동을 저해하는 모든 행위를
                            배제한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>2. 국가·사회 발전에 대한 공헌</h5>
                        <ol class="depth_03">
                          <li>
                            1) 학벌, 성별, 출신지역별 차별 없이 누구에게나
                            균등한 고용의 기회를 부여한다.
                          </li>
                          <li>2) 조세는 성실하게 신고하고 납부한다.</li>
                          <li>
                            3) 사회 가계 각층과 지역주민의 정당한 요구를
                            수용하며 이를 해결 하는데 최선을 다한다.
                          </li>
                          <li>
                            4) 임직원의 건전한 사회봉사활동 참여를 보장하고
                            권장한다.
                          </li>
                          <li>
                            5) 지속가능경영으로 사업활동의 체질을 끊임없이
                            개선하며 기업가치를 제고한다.
                          </li>
                          <li>
                            6) 기업경영 전반에 윤리성을 근간으로 비즈니스
                            파트너들과 상호 협력하고 동반성장 함으로써
                            국가발전에 이바지 한다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>3. 주주의 권리 및 이익 보호</h5>
                        <ol class="depth_03">
                          <li>
                            1) 주주의 알 권리와 정당한 요구, 제안, 공식적 결정을
                            존중한다.
                          </li>
                          <li>
                            2) 직무상 취득한 내부 또는 타기업의 정보를 이용하여
                            주식의 매매 등을 하지 않는다.
                          </li>
                          <li>
                            3) 대주주의 이익보호를 위하여 일방적으로 소액주주의
                            이익을 침해 하지 않는다.
                          </li>
                          <li>
                            4) 정확한 회계처리 및 공시를 통해 회계의 투명성을
                            확보한다.
                          </li>
                          <li>
                            5) 거래관행이 투명하지 않은 개인, 거래처, 국가와의
                            거래는 가급적 삼가고, 불법적인 허위, 변칙거래를 하지
                            않는다.
                          </li>
                        </ol>
                      </li>
                      <li>
                        <h5>4. 환경의 보호</h5>
                        <ol class="depth_03">
                          <li>
                            1) 환경보호에 위배되는 사업활동을 금지하며 공해 및
                            오염방지를 위한 적절한 투자를 한다.
                          </li>
                          <li>
                            2) 환경보호를 위해 적극적으로 환경보호 활동을
                            전개하며, 환경보호 관련 국제기준, 관계법령, 내부규정
                            등을 준수한다.
                          </li>
                          <li>
                            3) 제품의 개발, 생산, 유통, 판매 및 폐기의 모든
                            사업활동에서 환경 보호를 우선적으로 고려한다.
                          </li>
                        </ol>
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                </ol>
                <!--depth01-->
              </div>
            </div>
          </li>
          <!-- //윤리규범 -->
          <!-- 실천지침 -->
          <li :class="{ active: tabActs[1] }">
            <div class="tab_inner charter_txt">
              <div>
                <ol class="depth_01">
                  <li>
                    <h4>제 1 장 총칙</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 목적</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            한국오션플랫폼㈜는 ‘한국오션플랫폼㈜ 윤리규범’의
                            실천을 강화하기 위하여 ‘한국오션플랫폼㈜ 윤리규범
                            실천지침’을 제정하여 전 임직원의 윤리적 의사결정 및
                            행동원칙으로 삼는다. 전 임직원은 회사업무를 수행함에
                            있어 ‘한국오션플랫폼㈜ 윤리규범 실천지침’을 철저하게
                            준수해야 한다. 본 자료는 ‘한국오션플랫폼㈜ 윤리규범
                            실천지침’의 시행과 관련하여 금품, 향응, 접대,
                            편의수수, 신고절차 등 필요한 제반 사항에 대해
                            구체적으로 규정함을 목적으로 한다.
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>2. 용어의 정의</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 임직원
                            <ul class="dash_sty">
                              <li>
                                회사에 근로를 제공하는 대가로 임금을 지급받는
                                일체의 임원 및 직원을 말하며, 회사와 업무의 일부
                                또는 전부를 대행하는 계약을 체결한 경우 그
                                사람도 사안에 따라 임직원으로 볼 수 있다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            2) 가족
                            <ul class="dash_sty">
                              <li>
                                임직원의 배우자와 본인 및 배우자의 직계비속과
                                4촌 이내의 친인척 관계에 있는 사람을 말한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            3) 직무
                            <ul class="dash_sty">
                              <li>
                                직책이나 직급상 역할과 책임을 부여 받은 업무로서
                                의사결정을 통해 이해관계자가 이익 또는 손실이
                                발생할 가능성이 있는 경우를 포함한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            4) 이해관계자
                            <ul class="dash_sty">
                              <li>
                                업무와 관련한 임직원의 행위나 의사결정으로 인해
                                그 권리와 이익에 영향을 받는 사내, 사외의 모든
                                자연인, 법인, 기타 단체를 말한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            5) 금품
                            <ul class="dash_sty">
                              <li>
                                현금, 수표, 상품권, 유가증권은 물론 부채상환,
                                보증, 대출이자 대납, 동산 혹은 부동산의 무상,
                                염가제공 등 일체의 금전적 혜택을 포함한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            6) 선물
                            <ul class="dash_sty">
                              <li>
                                대가 없이 제공되는 물품, 회원권, 숙박권, 입장권
                                및 이에 준하는 것을 의미한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            7) 기념품
                            <ul class="dash_sty">
                              <li>
                                공식적인 행사에서 주최자가 참석자에게 일률적으로
                                제공하거나, 불특정 다수인에게 배포하기 위한 물품
                                또는 회사 로고가 기재되어 있는 물품을 의미하며
                                경품 및 시상품을 포함한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            8) 향응/ 접대
                            <ul class="dash_sty">
                              <li>
                                식사, 음주, 스포츠(골프 등), 오락, 불건전업소
                                등에서 발생한 비용을 부담하거나 부담시키는
                                행위를 말한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            9) 편의제공
                            <ul class="dash_sty">
                              <li>
                                금품, 향응접대 이외의 숙박 및 교통제공,
                                관광안내, 각종 행사지원 등 수취인이 편의를
                                누리기 위해 상대방에게 경제적인 손실을 발생하게
                                하는 모든 경우를 말한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            10) 통상적 수준
                            <ul class="dash_sty">
                              <li>
                                일반인이 건전한 상식으로 판단할 때 이해할 수
                                있는 수준으로서 수혜자가 부담을 가지지 않고
                                업무를 처리할 수 있는 정도를 의미한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            11) 이해관계의 상충
                            <ul class="dash_sty">
                              <li>
                                회사의 업무를 효과적이고 공정하게 수행할 수 있는
                                임직원의 능력이 외부의 임명, 관계 및 활동 등에
                                의하여 잠재적 혹은 실제적으로 제약을 받는 상황을
                                말한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            12) 협력회사
                            <ul class="dash_sty">
                              <li>
                                한국오션플랫폼㈜ 내 모든 회사와 거래관계에 있는
                                개인이나 법인을 말한다.
                              </li>
                            </ul>
                          </li>
                          <li>
                            13) 신고자
                            <ul class="dash_sty">
                              <li>
                                금전 등의 수수 및 동 사실의 인지와 관련하여
                                신고의무가 있는 모든 임직원을 말한다.
                              </li>
                            </ul>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>3. 적용범위</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            본 지침은 한국오션플랫폼㈜ 내 모든 회사의 임직원 및
                            협력회사와 그 임직원에 대하여 적용된다.
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                  <li>
                    <h4>제 2 장 업무수행 기준</h4>
                    <!--depth02-->
                    <ol class="depth_02">
                      <li>
                        <h5>1. 이해관계자로부터 사례를 받는 행위</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 기본원칙
                            <ol class="depth_04">
                              <li>
                                (1) 이해관계자에 의한 사례는 이유여하를 불문하고
                                받아서는 안되며, 선물의 경우 정중하게 거절하거나
                                되돌려 준다.
                              </li>
                              <li>
                                (2) 이해관계자로부터 불가피하게 사례를 받았을
                                경우 규정된 신고절차에 따라 반드시 신고를 한다.
                              </li>
                              <li>
                                (3) 회사 임직원 가족이라도 이해관계자로부터
                                업무와 관련하여 제공된 것으로 생각되는 사례를
                                받거나 요구하지 않는다.
                              </li>
                            </ol>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>2) 대상행위 및 판단기준</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            [금전수수] <sup>1)</sup>
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  금전수수 : 구분, 예시, 원칙, 비고로 이루어진
                                  표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">금전</th>
                                    <td>현금, 수표, 유가증권 등</td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">선물</th>
                                    <td>
                                      골프연습장 이용권, 헬스클럽 이용권,
                                      상품권, 관람권, 물품 등 기타 판촉 및
                                      할인혜택 포함
                                    </td>
                                    <td>금지</td>
                                    <td>
                                      원칙적으로 수수금지, 불가피한 경우
                                      5만원/회, 총액 10만원 이하<br />
                                      단, 판촉 및 할인혜택이 불특정 다수가
                                      대상인 경우는 허용
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="col">경조금</th>
                                    <td>
                                      경조금, 경조물품<br />(화환, 화분, 돌반지
                                      등)
                                    </td>
                                    <td>금지</td>
                                    <td>
                                      원칙적으로 수수금지<br />
                                      단, 불가피한 경우 5만원/회, 총액 10만원
                                      한도/년
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="col">협찬</th>
                                    <td>
                                      접대비, 회식비 및 기타 개인경비를
                                      이해관계자에게 전가하는 경우
                                    </td>
                                    <td>금지</td>
                                    <td>불가피한 경우 사후 환불</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <sup>1)</sup>유가증권을 포함한 금전 및 선물
                          </li>
                          <li>
                            [향응 및 접대]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  향응 및 접대 : 구분, 예시, 원칙, 비고로
                                  이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">식사</th>
                                    <td>이해관계자와의 식사 및 간단한 음주</td>
                                    <td>금지</td>
                                    <td>
                                      원칙적으로 수수금지<br />
                                      단, 불가피한 경우 한도내 에서 허용함<br />
                                      (5만원/인, 20만원/년)
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="col">불건전업소</th>
                                    <td>
                                      룸싸롱, 단란주점, 나이트클럽, 안마시술소,
                                      고급이발소, 고급사우나 등
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">오락</th>
                                    <td>고스톱, 내기골프 ,카지노, 카드</td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">스포츠</th>
                                    <td>골프, 스키</td>
                                    <td>금지</td>
                                    <td>
                                      회사에서 승인한 공식적 모임 외
                                      이해관계자와의 접대성 모임 금지
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                          <li>
                            [편의 제공]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  편의 제공 : 구분, 예시, 원칙, 비고로 이루어진
                                  표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">출장지원</th>
                                    <td>
                                      교통편의(철도, 항공, 버스 승차권, 차량지원
                                      등) 및 숙식편의(숙박, 식사 등)
                                    </td>
                                    <td>적정대가지불</td>
                                    <td>
                                      업무효율을 위해 이해관계자가 제공하는
                                      편의를 이용하는 경우 반드시 정당한 대가를
                                      지불해야 함
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="col">개인휴가 지원</th>
                                    <td>
                                      개인적 휴가에 교통 및 숙박편의 제공,
                                      관광안내 등
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">
                                      사무실 이전비용 비품지원
                                    </th>
                                    <td>
                                      부서 이전비용 또는 사무용 비품(벽시계,
                                      거울 등) 지원
                                    </td>
                                    <td>금지</td>
                                    <td>
                                      원칙적 금지<br />
                                      단, 불가피한 경우 <br />
                                      선물범위 내에서 인정
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="col">협찬·찬조</th>
                                    <td>
                                      사내행사 등 협찬(금전, 물품, 교통편의
                                      등)/업무와 무관한 이해관계자의
                                      초청행사(국내/외 세미나 등)
                                    </td>
                                    <td>금지</td>
                                    <td>
                                      회사 사전승인 외 초청금지 및 이해관계자
                                      초청행사 <br />
                                      참여금지
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                          <li>
                            [차용(동산 및 부동산), 부채상환, 보증, 금전대차]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  차용(동산 및 부동산), 부채상환, 보증, 금전대차
                                  : 구분, 예시, 원칙, 비고로 이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col" rowspan="2">
                                      차용<br />
                                      염가매도<br />
                                      고가매도
                                    </th>
                                    <td>
                                      동산, 부동산 등 이해관계자의 자산을 임차,
                                      담보설정, 무상수수, 염가매입 등<br />임직원
                                      개인소유 자산의 고가 매도
                                    </td>
                                    <td rowspan="2">금지</td>
                                    <td rowspan="2">개인편의 및 영리 목적</td>
                                  </tr>
                                  <tr>
                                    <td>임직원 개인소유 자산의 고가 매도</td>
                                  </tr>
                                  <tr>
                                    <th scope="col">부채상환</th>
                                    <td>
                                      신용카드 대금, 외상대금, 대출금 등
                                      개인부채의 결제 또는 대리 상환
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">보증</th>
                                    <td>대출에 대한 보증 요구 /보증 제의</td>
                                    <td>금지</td>
                                    <td>금융기관 및 모든 형태의 대출 불문</td>
                                  </tr>
                                  <tr>
                                    <th scope="col">금전대차</th>
                                    <td>
                                      이해관계자와 금전을 빌리거나 빌려주는
                                      행위, 그에 따른 이자 지금 또는 수취 행위
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                          <li>
                            [미래에 대한 보장]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  [미래에 대한 보장] : 구분, 예시, 원칙, 비고로
                                  이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">고용알선</th>
                                    <td>
                                      이해관계자로부터 퇴직후 고용보장, 취업알선
                                      약속 등을 받는 행위
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">계약체결 약속</th>
                                    <td>
                                      퇴직후 사업거래 약속 체결 등을 하는 행위
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>2. 거래업체에 대한 부당지분 참여</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 기본원칙
                            <ol class="depth_04">
                              <li>
                                (1) 이해관계가 있는 거래업체의 사장. 비상장
                                증권에 대한 부당한 지분취득을 하지 않는다.
                              </li>
                              <li>
                                (2) 이해관계자와의 공동투자 및 공동재산 획득은
                                부당한 행위이며, 이를 위한하는 경우 실질지분
                                소유관계에 근거하여 지분에 해당 하는 금액을
                                이해관계자로부터 수취한 것으로 간주한다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            2) 대상행위 및 판단기준
                            <br />[주식수수 및 투자]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  [주식수수 및 투자] : 구분, 예시, 원칙, 비고로
                                  이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">상장주식</th>
                                    <td>
                                      회사와 거래관계에 있는 보유주식 전체
                                    </td>
                                    <td>회사의 원칙에 따라 정리 및 매매금지</td>
                                    <td>
                                      계열사, KOSPI200, KOSDAQ50에 포함된 회사는
                                      제외, 이외의 경우는 회사에 영향력을 미칠
                                      수 있는지에 따라 거래여부 결정
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="col">비상장 주식</th>
                                    <td>
                                      회사와 거래관계에 있는 보유주식 전체
                                    </td>
                                    <td>즉각정리 및 매매 금지</td>
                                    <td>
                                      비상장주식은 어떤 경우에도 주식의 소유 및
                                      매매를 금지함
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            [공동투자 및 공동재산 취득]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  [공동투자 및 공동재산 취득] : 구분, 예시,
                                  원칙, 비고로 이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">
                                      공동투자<br />공동재산<br />취득
                                    </th>
                                    <td>
                                      자금의 공동투자를 통한 동산/부동산의
                                      취득(콘도,헬스클럽 등의 회원권, 부동산
                                      투자 등)
                                    </td>
                                    <td>금지</td>
                                    <td>신고 후 지분정리</td>
                                  </tr>
                                  <tr>
                                    <th scope="col">합작투자<br />사업</th>
                                    <td>
                                      자금의 공동투자, 명의 등재 등을 통한
                                      공동회사 보유 및 합작투자에 의한 사업 영위
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">협력회사<br />겸직</th>
                                    <td>
                                      이해관계자의 회사에 이사 등재, 직원 겸직
                                      및 실질적 업무수행 행위
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>3. 협력업체와의 거래에 있어 투명성 유지</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 기본원칙
                            <ol class="depth_04">
                              <li>
                                (1) 협력회사와의 거래에 있어 공정거래에 관한
                                법률을 엄격히 준수한다.
                              </li>
                              <li>
                                (2) 거래 공급업체는 공정하고 투명한 원칙에
                                근거하여 공급자를 선정해야 한다. 이는 대량
                                구매계약뿐만 아니라 간단한 서비스 계약까지를
                                포함한 모든 거래에서 준수되어야 한다.
                              </li>
                              <li>
                                (3) 거래관계에 있어 협력회사에 대해 거래조건에
                                대한 제한 또는 조정이 필요한 경우 명백하고
                                타당한 사유 및 투명한 절차에 의해 진행한다.
                              </li>
                              <li>
                                (4) 거래상의 우월적 지위를 이용하여 불평등,
                                부당한 대우, 불친절한 거래행위를 하지 않는다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            2) 대상행위 판단기준<br />[공정하지 않은 기회 부여]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  대상행위 판단기준 : 구분, 예시, 원칙, 비고로
                                  이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">거래거절</th>
                                    <td>
                                      정당한 사유 없이 거래참여 거절/기회 박탈
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">참여제한</th>
                                    <td>
                                      배타적인 거래조건 설정, 근거 없이 거래지역
                                      설정, 거래 상대방의 한정
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col" rowspan="2">차별</th>
                                    <td>
                                      가격/거래조건 차별, 담합을 통한 집단 차별
                                    </td>
                                    <td rowspan="2">금지</td>
                                    <td rowspan="2"></td>
                                  </tr>
                                  <tr>
                                    <td>
                                      특정업체에 대하여 특혜 부여(높은 단가,
                                      거래조건 등)
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            [공정하지 않은 거래 행위]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  공정하지 않은 거래 행위 : 구분, 예시, 원칙,
                                  비고로 이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th rowspan="2" scope="col">부당거래</th>
                                    <td>
                                      일방적 납품물량 조절, 부당 염가 매입,
                                      계약조건의 일방적 변경, 대금결제의 고의적
                                      지연, 부당한 사유로 일방적 거래 단절
                                    </td>
                                    <td rowspan="2">금지</td>
                                    <td rowspan="2">
                                      거래조건의 변경사유 발생시 협력회사와
                                      합의절차 준수
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>특정업체에 대해서 부당 고가 매입</td>
                                  </tr>
                                  <tr>
                                    <th scope="col">부당지원</th>
                                    <td>부당한 자금, 인력, 자산 지원</td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="col">사업방해</th>
                                    <td>
                                      부당한 기술 이용, 협력회사 인력의 부당
                                      채용, 경쟁업체와의 거래 방해, 기타
                                      사업활동 방해
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            [협력업체 정보유출 행위]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  협력업체 정보유출 행위 : 구분, 예시, 원칙,
                                  비고로 이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col">정보유출</th>
                                    <td>
                                      협력업체로부터 획득한 제반 정보의 외부
                                      유출
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>4. 회사자산의 불법·부당한 사용</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 기본원칙
                            <ol class="depth_04">
                              <li>
                                (1) 회사의 유·무형자산 및 기밀정보 등은 회사의
                                중요한 자산으로 회사의 사업활동 및 승인된
                                목적으로만 사용되어야 한다.
                              </li>
                              <li>
                                (2) 회사의 비용은 공금으로 건전한 기업활동을
                                위해 사용되어야 한다. 따라서 정해진 목적에 맞게
                                사용되어야 한다.
                              </li>
                            </ol>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>2) 대상행위 및 판단기준</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            [유·무형자산의 타용도 사용]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  [유·무형자산의 타용도 사용] : 구분, 예시,
                                  원칙, 비고로 이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col" rowspan="3">
                                      유형자산<br />
                                      횡령·유용
                                    </th>
                                    <td>
                                      고정자산:토지,건물,설비기기 등
                                      유형고정자산을 사업목적 외 전용/무단사용,
                                      개인 영리목적 이용
                                    </td>
                                    <td rowspan="3">금지</td>
                                    <td rowspan="3"></td>
                                  </tr>
                                  <tr>
                                    <td>
                                      업무용자산: 차량,PC,고가의 소모품,
                                      사무용품 등 업무용자산을 무단반출/사용,
                                      가족/친지 제공, 유지비용 전가 등
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      법인카드: 한도를 초과한 과다사용,
                                      비용계정의 전용, 개인용도 사용 등
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="col">무형자산 유용</th>
                                    <td>
                                      제품 설계도의 유출, 영업기밀/사업정보 유출
                                      등을 통한 자신의 이익 목적에 사용 또는
                                      경쟁업체에 제공
                                    </td>
                                    <td>금지</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            [공금횡령 및 유용]
                            <div class="tbl_doc">
                              <table>
                                <caption>
                                  [공금횡령 및 유용] : 구분, 예시, 원칙, 비고로
                                  이루어진 표
                                </caption>
                                <thead>
                                  <tr>
                                    <th scope="row">구분</th>
                                    <th scope="row">예시</th>
                                    <th scope="row">원칙</th>
                                    <th scope="row">비고</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="col" rowspan="2">
                                      공금횡령 및 유용
                                    </th>
                                    <td>
                                      회사공금의 무단인출, 사적인 융통, 회계장부
                                      조작 등을 통한 개인 착복, 이해관계자에
                                      증여
                                    </td>
                                    <td rowspan="2">금지</td>
                                    <td rowspan="2"></td>
                                  </tr>
                                  <tr>
                                    <td>
                                      법인카드 불법전용(카드 깡 등), 허위
                                      영수증을 통한 비용처리(개인사용 영수증
                                      등), 무증빙제도의 악용, 개인 유흥 또는
                                      회계처리가 어려운 접대성 경비 등을 타
                                      계정의 비용으로 합산 처리, 회사 법인카드를
                                      가족/친지에게 제공하여 무단 사용, 기타
                                      회사 경비처리 기준에 반하는 사적인 집행
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>5. 문서의 계수조각 및 허위보고</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 기본원칙
                            <ol class="depth_04">
                              <li>
                                (1) 모든 정보의 기록과 보고는 정확하고 정직해야
                                한다.
                              </li>
                              <li>
                                (2) 임직원의 고의 또는 부주의로 인한 사실과 다른
                                문서, 계수의 조작은 상급관리자나 관련부서의
                                인사결정 및 판단을 흐리게 하거나 오판하게 할 수
                                있음을 인식하고 주의해야 한다.
                              </li>
                              <li>
                                (3) 특히, 결산을 포함한 모든 회계문서는 세법과
                                기업회계기준에 따라 공정하게 작성하여 주주 등
                                이해관계자에게 보고해야 한다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            2) 대상행위 및 판단기준
                            <ol class="depth_04">
                              <li>
                                (1) 문서의 계수조작
                                <ol class="depth_05">
                                  <li>
                                    ① 임직원이 정보를 기록하고 회사에 제출하는
                                    일정한 종류의 모든 문서 및 계수는 정확하고
                                    정직하게 작성한다.
                                  </li>
                                  <li>
                                    ② 상급관리자가 문서 또는 계수에 대한 조작을
                                    지시하거나, 혹은 하급자가 이런 지시가
                                    명백하게 부정한 행위임을 알고도 용인하는
                                    것은 동일한 불법행위로 처벌을 받는다.
                                  </li>
                                </ol>
                              </li>
                              <li>
                                (2) 허위보고
                                <ol class="depth_05">
                                  <li>
                                    ① 회사내의 경영진이나 인사총무팀 또는 회사
                                    외부의 조직이나 사람들에게 부정직한
                                    허위보고를 하는 것은 불법행위로 판단하여
                                    엄격하게 금지한다.
                                  </li>
                                  <li>
                                    ② 고객에게 상품을 판매하거나 서비스를
                                    제공하는 경우에 허위 진술을 하는 경우도
                                    부정행위로 간주한다.
                                  </li>
                                  <li>
                                    ③ 직접적인 허위보고 이외에도 정보 수령자의
                                    오해를 꾀하려는 목적의 정보조작 역시 동일한
                                    부정행위로 간주한다.
                                  </li>
                                </ol>
                              </li>
                            </ol>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>6. 직장내 성희롱 방지</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 기본원칙<br />직장내 성희롱은 피해자에게
                            근무의욕의 상실, 업무 생산성 저하를 가져오며, 결국
                            회사에 기업 이미지 손상, 법적 소송 등의 부담을
                            가져올 수 있기 때문에 철저히 예방을 해야 한다.
                            <ul class="depth_04">
                              <li>
                                (1) 음담패설을 삼가고 회식 때 술시중이나 춤을
                                강요하지 않는다.
                              </li>
                              <li>
                                (2) 직장에서 음란한 인터넷 사이트나 동영상,
                                사진을 보지 않는다.
                              </li>
                              <li>
                                (3) 직장 동료의 신체에 대해 성적인 평가나 비유를
                                하지 않는다.
                              </li>
                              <li>
                                (4) 불필요한 신체접촉을 삼가고 고정된 성 역할을
                                강조하는 말(여자 또는 남자이기 때문에)을 하지
                                않는다.
                              </li>
                            </ul>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>7. 포상 및 징계, 예외사항의 해석</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 포상 및 징계
                            <ol class="depth_04">
                              <li>
                                (1) 회사는 윤리경영 실천에 공로가 있는
                                임직원에게 관련 규정에 따라 포상 또는 적정한
                                보상금을 지급할 수 있다.
                              </li>
                              <li>
                                (2) 회사는 윤리규범을 위반한 임직원에 대해서
                                사규에 따라 처벌할 수 있다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            2) 예외사항의 해석
                            <ol class="depth_04">
                              <li>
                                (1) 윤리규범에 구체적으로 수록되어 있지 않거나
                                해석상에 분쟁의 소지가 발생한 경우에는
                                인사총무팀에 문의하여 그 해석에 따른다.
                              </li>
                            </ol>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>8. 윤리경영 위반사항의 신고</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            1) 기본원칙
                            <ol class="depth_04">
                              <li>
                                (1) 임직원은 윤리규범 위반사항을 인지한 때 또는
                                제 3자로부터 그러한 상황을 접수한 때는 반드시
                                회사에 보고를 해야 하며, 회사는 신고를 접수할 수
                                있는 ‘사이버신문고’를 인사총무팀 주관으로
                                사내홈페이지 및 외부홈페이지에 설치하여 운영해야
                                한다.
                              </li>
                              <li>
                                (2) 회사는 내부 비리 신고자에 대해서는 비밀을
                                유지해야 하며, 인사상 불이익을 주는 행위를
                                해서는 안된다.
                              </li>
                              <li>
                                (3) 내부비리 신고자에 대해 그 사실을 이유로
                                보복행위를 하는 자는 사내규정이 정하는
                                범위내에서 가중처벌을 할 수도 있다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            2) 신고의무
                            <ol class="depth_04">
                              <li>
                                (1) 임직원은 본인 또는 타인의 윤리규범 및 지침의
                                위반사항을 인지한 즉시 윤리경영 주관부서인
                                인사총무팀에 신고를 해야 한다.
                              </li>
                              <li>
                                (2) 임직원은 이해관계가 발생하였거나, 이해관계가
                                발생할 우려가 있는 경우에도 신고를 해야 한다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            3) 위반에 대한 징계
                            <ol class="depth_04">
                              <li>
                                (1) 임직원은 윤리규범 및 본 지침을 위반하거나
                                타인의 위반 사실을 묵인 또는 방조한 경우 징계의
                                대상이 된다.
                              </li>
                              <li>
                                (2) 윤리규범 및 본 지침을 위반한 임직원이 그
                                사실을 자진 신고한 경우에 회사는 정상참작을 하여
                                징계를 경감해 줄 수 있다.
                              </li>
                              <li>
                                (3) 징계에 대한 사항은 별도의 사규에 따라
                                시행한다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            4) 제보자의 보호
                            <ol class="depth_04">
                              <li>
                                (1) 윤리경영 위반에 관한 제보자 및 제보관련 참고
                                진술자의 노출을 원칙적으로 금지한다.
                              </li>
                              <li>
                                (2) 제보자 및 제보관련 참고 진술자의 신원을
                                인지한 임직원은 신분의 비밀을 보장해야 하며,
                                제보자 및 제보관련 참고 진술자에게 어떠한
                                불이익을 주어서도 안된다.
                              </li>
                              <li>
                                (3) 신분노출, 차별대우 등 불이익을 받은 제보관련
                                참고 진술자는 인사총무팀에 보호조치나 구제를
                                신청할 수 있으며, 인사총무팀은 제보자 및
                                제보관련 참고 진술자에게 필요하다고 판단되는
                                적절한 조치를 취해야 한다.
                              </li>
                              <li>
                                (4) 제보자의 신분이 노출된 경우 인사총무팀은
                                신분노출 경로에 대해 조사를 하고, 고의 또는
                                과실로 제보자의 신분을 노출한 임직원은 징계의
                                대상이 될 수 있다.
                              </li>
                            </ol>
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                      <li>
                        <h5>9. 윤리교육의 수립 및 실시 등</h5>
                        <!--depth03-->
                        <ol class="depth_03">
                          <li>
                            (1) 교육 운영 일정
                            <ol class="depth_04">
                              <li>① 계획 수립: 매년 초 교육 계획 수립</li>
                              <li>
                                ② 교육 이수 기간: 연단위로 운영 (매년 01.01 ~
                                12.31)
                              </li>
                              <li>
                                ③ 세부 교육일정: 회사의 연간 교육 일정을
                                고려하여 해당 교육일정 수립, 교육 프로그램에
                                따라 연간 최소 1회 이상 실시
                              </li>
                            </ol>
                          </li>
                          <li>
                            (2) 교육 진행 방법: 교육 대상 및 교육 프로그램별
                            적합한 교육 진행 방법의 선택
                            <ol class="depth_04">
                              <li>① 진행 방식: 집합 교육 또는 온라인 교육</li>
                              <li>② 교육 장소: 사내 또는 사외</li>
                              <li>③ 교육 주기: 정기 또는 비정기</li>
                            </ol>
                          </li>
                          <li>
                            (3) 교육 프로그램은 일반윤리 및 준법교육을 포함하며
                            교육 대상자별 의무 이수 교육시간을 고려하여 해당
                            교육 프로그램을 구성하여야 한다. 프로그램은 교육
                            주체에 따라 사내 및 사외 프로그램으로 구분될 수
                            있으며, 사내 및 사외 프로그램 운영에 있어 고려되어야
                            할 사항은 다음과 같다.
                            <ol class="depth_04">
                              <li>
                                ① 사내 교육 프로그램 운영
                                <ul class="dot_lst">
                                  <li>
                                    사내 교육 프로그램 운영 시, 세부 교육 내용
                                    개발, 학습자료(교재) 개발, 평가방법 및
                                    도구개발 등
                                  </li>
                                  <li>
                                    교육 주제와 관련하여 전문지식을 지닌 임직원
                                    및 외부인사등을 초청하여 교육 프로그램 구성
                                  </li>
                                </ul>
                              </li>
                              <li>
                                ② 사외 교육 프로그램 이용
                                <ul class="dot_lst">
                                  <li>
                                    외부 교육기관에서 개설되어 있는 윤리 또는
                                    준법 관련 교육으로 구성
                                  </li>
                                  <li>
                                    외부 교육 이수 후, 참여 인원이 작성한 교육
                                    결과 보고서 또는 외부 교육기관의
                                    수료증·성적표 등의 증빙서류를 통해 교육
                                    이수를 확인하고 교육 이수 이력을 관리
                                  </li>
                                </ul>
                              </li>
                            </ol>
                          </li>
                          <li>
                            (4) 인사정책과의 연계
                            <ol class="depth_04">
                              <li>
                                ① 교육 의무 이수제의 운영을 통해 교육대상
                                임직원의 교육 이수 사항은 성과평가, 인센티브 및
                                보상 정책에 반영한다.
                              </li>
                              <li>
                                ② 교육이수 사항의 성과평가, 인센티브 및 보상
                                정책 평가 반영 비율은 인사부서가 결정하여
                                성과평가에 반영한다.
                              </li>
                            </ol>
                          </li>
                          <li>
                            (5) 현장교육(온라인교육 포함)을 원칙으로 하나
                            불가능한 경우(지방 및 해외지사) 관련 교육 자료를
                            전달하는 방식으로 진행한다.
                          </li>
                          <li>
                            (6) 참석하지 않은 인원에 대해 소속 팀장의 승인을
                            득한 사유서 등을 제출하고 재교육 및 부서성과평가
                            등에 반영하고 있다.
                          </li>
                          <li>
                            (7) 윤리규범의 교육 수행 결과는 대표이사에게
                            보고한다.
                          </li>
                        </ol>
                        <!--//depth03-->
                      </li>
                    </ol>
                    <!--//depth02-->
                  </li>
                </ol>
                <!--depth01-->
              </div>
            </div>
          </li>
          <!-- //실천지침 -->
        </ul>
      </div>
    </div>
    <div class="sub_contents" v-else>
      <div>
        <dl class="ethical_tit">
          <dt><em>윤리경영</em>이란</dt>
          <dd>
            기업의 경제적 · 법적 책임 수행은 물론 사회적 통념에 요구되는 윤리적
            책임을 기본 의무로 인정하고 기업윤리 준수를 기업 경영활동에 반영하는
            것을 의미합니다. 한국오션플랫폼은 윤리적 기업문화가 정착하도록
            여러분의 소중한 의견에 귀 기울이고 있습니다.
          </dd>
        </dl>
        <ul class="ethical_con gs_y">
          <li>
            <img :src="`${resources}img/img_ethical01.jpg`" alt="" />
            <strong>비리행위 신고</strong>
            <p>
              임직원의 금품, 향응을 수수하는<br />
              행위 등 비리사실에 대한 신고
            </p>
          </li>
          <li>
            <img :src="`${resources}img/img_ethical02.jpg`" alt="" />
            <strong>갑질행위 신고</strong>
            <p>임직원에게 겪은 폭언, 폭행 행위에 대한 신고</p>
          </li>
          <li>
            <img :src="`${resources}img/img_ethical03.jpg`" alt="" />
            <strong>직장 내 괴롭힘 &middot; 성희롱 신고</strong>
            <p>
              직장 내 괴롭힘이나 성희롱을<br />
              당한 경우 신고
            </p>
          </li>
        </ul>
        <div class="btn_area">
          <a
            href="//ethics.lsholdings.co.kr/ko/view/report.asp?cn=013000"
            class="btn_move"
            target="_blank"
            rel="noreferrer noopener"
            >사이버 신문고에 제보하기</a
          >
        </div>
        <div
          v-toggle="{
            target: 'tabItemRef',
            selector: '.tab_area2 .tab_item a',
            onTag: 'a',
            onClass: 'actvie',
            dataType: Boolean,
          }"
          @onChange="changeTab"
          ref="tabItemRef"
        >
          <h3 class="pd_b20"><strong>윤리규범</strong></h3>
          <p class="subtit">
            한국오션플랫폼의 임직원이라면 누구나 지키고 발전시켜 나가야 할
            윤리적 가치와 행동 기준입니다.
          </p>
          <div class="tab_area2">
            <!-- 2021-08-18 : 탭 메뉴 -->
            <div class="tab_item">
              <!-- 탭 메뉴 active 클래스 추가 시 on-->
              <a href="#" :class="{ active: tabActs[0] }">윤리규범</a>
              <a href="#" :class="{ active: tabActs[1] }">실천지침</a>
            </div>
          </div>
          <ul class="tab_Con">
            <!-- 2021-08-18 : 탭 컨텐츠 -->
            <!-- 윤리규범 -->
            <li :class="{ active: tabActs[0] }">
              <!-- 탭 메뉴 active 클래스 추가 시 on-->
              <div class="tab_inner charter_txt">
                <div>
                  <p class="profess">
                    (전문)<br />
                    <br />한국오션플랫폼㈜는 경영철학의 근간인 윤리성(Integrity)
                    바탕으로 한국오션플랫폼㈜ 모든 임직원이 지켜야 할 바른
                    행동과 가치판단의 기준으로써 ‘한국오션플랫폼㈜ 윤리규범 및
                    실천 지침’을 정비하고 적극적인 실천과 지속적인 발전을 추구해
                    나간다.
                  </p>

                  <!--depth01-->
                  <ol class="depth_01">
                    <li>
                      <h4>제 1 장 고객에 대한 책임과 의무</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 고객의 존중</h5>
                          <ol class="depth_03">
                            <li>
                              1) 고객의 의견을 경청하고 존중하며 고객의 요구는
                              항상 옳다고 생각한다.
                            </li>
                            <li>
                              2) 고객만족을 모든 판단 및 행동에 있어 최우선
                              기준으로 삼는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>2. 진실한 정보 제공</h5>
                          <ol class="depth_03">
                            <li>
                              1) 고객에게 진실한 정보만을 전하며, 허위 사실을
                              유포하거나 허위 정보를 제공하지 않는다.
                            </li>
                            <li>
                              2) 고객이 마땅히 알아야 할 정보를 감추지 않으며,
                              경쟁사의 제품을 비방하거나 근거 없는 비교를 하지
                              않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>3. 고객에 대한 응대</h5>
                          <ol class="depth_03">
                            <li>1) 고객과의 약속은 반드시 지킨다.</li>
                            <li>
                              2) 고객으로부터 정당한 교환요청이나 반품 요구가
                              있는 경우 신속하게 응답한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>4. 고객에 대한 가치 제공</h5>
                          <ol class="depth_03">
                            <li>
                              1) 윤리성과 주인의식을 가지고 상호 존중과 배려,
                              신뢰를 통해 고객에게 참되고 실질적인 가치를 제공할
                              수 있도록 노력한다.
                            </li>
                            <li>
                              2) 고객의 요구에 맞는 제품과 서비스를 합리적인
                              가격으로 제공하며, 고객의 정당한 요구에는 신속하고
                              정확하게 대응한다.
                            </li>
                            <li>
                              3) 품질 신뢰성 및 안정성에 대한 고객의 기대와
                              요구사항을 충족하는 제품을 공급하기 위해
                              품질관리를 철저하게 한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>5. 고객의 이익 보호</h5>
                          <ol class="depth_03">
                            <li>
                              1) 고객의 재산을 내 것처럼 보호하고 임의로
                              사용하지 않는다.
                            </li>
                            <li>
                              2) 고객의 정보를 취득한 경우 무단 사용하거나
                              누설하지 않는다.
                            </li>
                            <li>
                              3) 고객의 이익과 안전을 침해하는 비도덕적 행위를
                              하지 않는다.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                    <li>
                      <h4>제 2 장 공정한 경쟁(경쟁사)</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 정당한 정보의 입수 및 활용</h5>
                          <ol class="depth_03">
                            <li>
                              1) 부당한 방법으로 경쟁사의 정보나 영업비밀을
                              취득하지 않는다.
                            </li>
                            <li>
                              2) 정당하게 입수된 경쟁사의 정보라도 부당하게 외부
                              누설 않는다.
                            </li>
                            <li>
                              3) 입수된 정보는 소비자 및 경쟁사에 피해를 주지
                              않도록 정당하게 활용한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>2. 정당한 경쟁우위 확보</h5>
                          <ol class="depth_03">
                            <li>
                              1) 경쟁사가 보유한 모든 분야의 유. 무형자산을
                              도용하거나 무단으로 침해하지 않는다.
                            </li>
                            <li>
                              2) 경쟁사에 대한 경쟁우위 확보를 위해 광고 등으로
                              상대방을 비방 하거나 근거 없는 상호 비교를 하지
                              않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>3. 부당한 담합금지</h5>
                          <ol class="depth_03">
                            <li>
                              1) 경쟁사와 판매가격, 판매조건 및 지역배분 등에
                              대해 담합하여 고객에게 피해를 주지 않는다.
                            </li>
                            <li>
                              2) 동종 거래처들과 부당한 협의체 또는 담합기구를
                              구성하거나 가입하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>4. 법규 및 상관습의 존중</h5>
                          <ol class="depth_03">
                            <li>
                              1) 국내 및 해외에서의 모든 사업활동은 해당 국가의
                              제반 법규를 준수하고 상거래 관습을 존중한다.
                            </li>
                            <li>
                              2) 국제개발기구(OECD)의 ‘국제 상거래 뇌물방지
                              협약’ 과 한국법의 ‘국제 상거래 뇌물 방지법’을
                              준수한다.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                    <li>
                      <h4>제 3 장 공정한 거래(협력업체)</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 공정한 절차에 의한 거래처 선정</h5>
                          <ol class="depth_03">
                            <li>
                              1) 거래처를 공정한 평가기준으로 선정, 등록할 수
                              있게 ‘거래처 선정절차에 관한 제반 규정과 제도’를
                              정립하고 실행한다.
                            </li>
                            <li>
                              2) 거래처 선정절차는 사업별 특성을 고려하여
                              구체적인 평가항목과 평가방법을 선정한다.
                            </li>
                            <li>
                              3) 거래처를 선정하는데 있어 혈연, 지연, 학연 등
                              사사로운 이해관계나 압력, 청탁 등을 배제한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>2. 공정한 거래와 평가</h5>
                          <ol class="depth_03">
                            <li>
                              1) 협력업체와 partnership을 통해 상생협력과
                              동반성장을 실현한다.
                            </li>
                            <li>
                              2) 거래에 필요한 정보는 적절한 때에 서로 제공하며,
                              정보의 외부 노출로 인한 피해가 없도록 사전에
                              필요한 보안조치를 한다.
                            </li>
                            <li>
                              3) 공정한 기준에 따라 정기적으로 평가하며, 평가된
                              거래결과를 거래처에 통보하고 다음 거래에 반영한다.
                            </li>
                            <li>
                              4) 거래의 개선을 위해 제시된 건전한 의견은 업무에
                              반영한다.
                            </li>
                            <li>
                              5) 거래처의 기술이나 기타 자산을 사용할 경우
                              반드시 거래처의 승인을 받는다.
                            </li>
                            <li>
                              6) 회사가 명백히 잘못하여 거래처가 피해를 입는
                              경우 공정하게 배상한다.
                            </li>
                            <li>
                              7) 기타 공정거래 관련 법규에서 금지하고 있는
                              불공정한 행위를 하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>3. 깨끗하고 투명한 거래질서 유지</h5>
                          <ol class="depth_03">
                            <li>
                              1) 거래처로부터 금품, 용역, 향응, 기타 편의 등
                              경제적인 이익을 제공 받거나 요구하지 않는다.
                            </li>
                            <li>
                              2) 거래와 관련하여 혈연, 지연, 학연 등 특수관계에
                              의한 청탁이나 업무상의 지위를 이용하여 외부 압력을
                              행사하지 않는다.
                            </li>
                            <li>
                              3) 거래 과정에서 알게 된 협력업체의 정보 및 기술을
                              사전 승인 없이 이용함으로써 협력업체의 사업활동을
                              방해하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>4. 협력업체의 지원</h5>
                          <ol class="depth_03">
                            <li>
                              1) 협력업체의 실질적인 육성을 위해 협력업체 육성
                              지침을 제정하고 이를 준수한다.
                            </li>
                            <li>
                              2) 상기 지침은 협력업체의 자격, 권리, 의무를
                              명시하고 기술지원 및 경영지도 등 실질적 육성을
                              위한 운영기준을 포함한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>
                            5. 부당한 행위 금지<br />협력업체 및 이해관계자와의
                            거래에 있어 다음과 같은 부당한 행위를 하지 않는다.
                          </h5>
                          <ol class="depth_03">
                            <li>
                              1) 상품 또는 서비스를 제공하면서 부당하게 다른
                              상품 또는 제품의 구매를 강요하는 행위
                            </li>
                            <li>
                              2) 거래처와 경쟁사와의 거래를 부당하게 금지하거나,
                              거래지역 또는 거래상대를 부당하게 제한하는 행위
                            </li>
                            <li>
                              3) 거래처와 협의 없이 일방적으로 판매가격을
                              인상하거나, 구매가격을 인하하는 등의 부당한 가격
                              결정 행위
                            </li>
                            <li>
                              4) 거래처의 정당한 반품 요구를 거절하거나, 주문한
                              물품의 수령거부, 지연 및 부당하게 검사에서 불합격
                              처리하는 행위
                            </li>
                            <li>
                              5) 대금 결제조건에 대한 법적 의무를 이행하지 않는
                              행위
                            </li>
                            <li>
                              6) 특정 거래처를 차별하여 거래가격, 거래조건,
                              거래내용을 부당하게 대우하는 행위
                            </li>
                            <li>
                              7) 거래처와 서로 합의한 계약상 의무사항을
                              일방적으로 변경 또는 폐기하는 행위
                            </li>
                            <li>
                              8) 기타 공정거래에 관한 관계 법규에서 금지하고
                              있는 불공정 거래 행위
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                    <li>
                      <h4>제 4 장 임직원의 기본윤리</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 한국오션플랫폼㈜ 임직원으로서 품위 유지</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사의 명예와 개인의 품위 유지를 훼손시킬 수
                              있는 비도덕적이고 비윤리적인 행위를 하지 않는다.
                            </li>
                            <li>
                              2) 직장 내에서 필요한 기본적인 예의를 지키며,
                              각자의 사생활을 존중한다.
                            </li>
                            <li>
                              3) 각종 루머, 유언비어 조성 및 유포 등 조직 내
                              불신풍조를 조장하는 행위를 하지 않는다.
                            </li>
                            <li>
                              4) 조직관리에 있어 폭언, 인격비하 발언 등을 통해
                              사기를 저하시키고 조직문화를 해치는
                              사해(社害)행위를 하지 않는다.
                            </li>
                            <li>
                              5) 학벌, 성별, 종교, 혈연, 출신지역, 연령, 장애,
                              결혼여부, 국적, 인종 등에 따른 파벌이나 사조직을
                              결성하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>2. 회사재산 및 중요 정보의 보호</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사재산에 손실을 가져올 중요하고 긴급한 사태가
                              발생하거나 발생 가능성이 있는 경우 즉시 보고를
                              하고 조치를 취한다.
                            </li>
                            <li>
                              2) 회사의 물적재산, 지적재산권, 영업비밀 등은
                              철저하게 보호해야 하며 개인적인 목적을 위해
                              부당하게 사용하지 않는다.
                            </li>
                            <li>
                              3) 직위를 이용한 사적 이익 추구, 회사에서 얻은
                              비공개 정보를 이용한 불공정한 거래행위를 하지
                              않는다.
                            </li>
                            <li>
                              4) 회사의 기밀정보는 관련 규정에 의거 보안을
                              유지하며, 회사 정보의 대외 공개는 사전에 회사의
                              승인을 받는다.
                            </li>
                            <li>
                              5) 소셜 네트워크(페이스북, 블로그, 카페 등)나
                              인터넷을 통해 회사의 중요 문서나 정보를 부당하게
                              유출하거나 사용하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>3. 공정한 직무수행</h5>
                          <ol class="depth_03">
                            <li>
                              1) 공정한 직무수행을 위해 다음과 같은 행위를 하지
                              않는다.
                              <ul class="dash_sty">
                                <li>이해관계자로부터 사례를 받는 행위</li>
                                <li>
                                  이해관계자와의 공동투자, 공동재산취득,
                                  금전대차 행위
                                </li>
                                <li>회사 자산을 불법으로 사용하는 행위</li>
                                <li>직무태만, 관리감독 소홀, 월권 행위</li>
                                <li>
                                  직무를 이용하여 개인적 이익을 도모하는 행위
                                </li>
                                <li>문서 또는 계수를 조작하는 행위</li>
                                <li>직무와 관련이 없는 부당한 업무지시 행위</li>
                              </ul>
                            </li>
                            <li>
                              2) 업무와 이해관계가 있는 사람으로부터 사례를
                              제공받지 않으며, 부득이하게 사례를 받은 경우
                              회사에 신고한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>4. 정직하고 공정한 보고</h5>
                          <ol class="depth_03">
                            <li>
                              1) 사실과 다르게 문서 계수를 조작하거나 허위보고
                              함으로써 상위자 및 관련부서의 의사결정을 오도하지
                              않는다.
                            </li>
                            <li>
                              2) 모든 거래는 회계의 근간인 신뢰성과 객관성의
                              원칙에 의해 장부 등에 기록한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>5. 직위·직무를 이용한 부당한 행위 금지</h5>
                          <ol class="depth_03">
                            <li>
                              1) 재직 중에 직무상 이해관계자로부터 퇴직 후
                              피고용을 약속 받거나 이를 요구하지 않는다.
                            </li>
                            <li>
                              2) 직무상 이해관계자와 개인적인 사업상 계약을
                              체결하거나 자산임차, 금전대차 등의 거래를 하지
                              않는다.
                            </li>
                            <li>
                              3) 상위자는 그 조직 또는 하위자에게 개인적인 용무
                              등을 시키거나 묵시적으로 요구하지 않는다.
                            </li>
                            <li>
                              4) 상사는 부하직원에게 법규 및 사규에 맞지 않는
                              업무지시를 할 수 없으며, 상사로부터 법규 및 사규에
                              맞지 않는 지시를 받은 직원은 업무 수행을 거부할 수
                              있고, 그런 내용을 회사에 알린 경우에도 불이익을
                              받지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>6. 회사와의 이해상충 회피</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사와 이해가 상충될 가능성이 있는 외부업체를
                              직접 경영하거나 출자하지 않는다.
                            </li>
                            <li>
                              2) 회사와 경쟁관계에 있는 업체에 이중으로
                              공용되거나 회사의 이익과 상충되는 상담, 조언 등을
                              제공하지 않는다.
                            </li>
                            <li>
                              3) 타 회사에 고용되거나 타 회사에서 현 직무와
                              유사한 일을 수행하는 경우 그 사실을 반드시 사전
                              승인 받는다.
                            </li>
                            <li>
                              4) 내부 정보를 이용하여 본인이 회사 주식을
                              매개하거나 타인에게 회사 주식의 거래를 권유하지
                              않는다.
                            </li>
                            <li>
                              5) 가족이나 친지가 경영하는 업체를 거래회사로
                              선정하거나 거래하도록 영향력을 행사하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>7. 직장내 성희롱 방지</h5>
                          <ol class="depth_03">
                            <li>
                              1) 직장 내에서 성적 유혹이나 성적 수치심을
                              유발시키는 농담, 신체적 접근으로 개인의 인권을
                              침해하고 근무 의욕을 감소시키는 행위를 하지
                              않는다.
                            </li>
                            <li>
                              2) 자신의 언행이 다른 사람에게 정신적, 육체적
                              피해를 줄 수 있다는 점을 유념하여 항상 조심한다.
                            </li>
                            <li>
                              3) 지위 고하를 불문하고 회사 내에서 성희롱으로
                              인해 회사 생활에 지장이 생기거나 인격이 침해되는
                              일이 없도록 한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>8. 정치활동 금지</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사는 개인의 참정권과 정치 의사를 존중하되,
                              임직원의 신분으로 정치에 개입하지 않아야 한다.
                            </li>
                            <li>
                              2) 정치단체, 정당 또는 후보자에게 불법적인
                              기부금이나 자금을 제공하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>9. 윤리규범 준수</h5>
                          <ol class="depth_03">
                            <li>
                              1) 윤리규범을 성실하게 준수해야 하며, 위반한
                              경우에는 해당 행위에 대한 책임을 진다.
                            </li>
                            <li>
                              2) 윤리규범에 반하는 행위를 강요 받거나 부당한
                              행위를 인지한 경우에는 윤리경영 담당부서인
                              한국오션플랫폼㈜ 인사총무팀에 신고를 한다.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                    <li>
                      <h4>제 5 장 회사의 임직원에 대한 책임</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 인재의 육성</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사는 임직원을 자율적이고, 창의적인 인재로
                              육성할 수 있도록 필요한 제도를 갖추고 이를
                              지원하며 활성화 시킨다.
                            </li>
                            <li>
                              2) 상사는 부하를 도전적이고 강인한 인재로
                              육성하겠다는 의지로, 적성과 소질을 고려하여 필요한
                              충고와 지도를 한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>2. 능력과 업적에 대한 대우</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사는 임직원의 능력 향상을 위한 기회(교육,
                              직무이동, 진급, 보직결정 등)를 학벌, 성별, 종교,
                              출신지역, 연령, 장애, 결혼여부, 국적, 인종 등에
                              따라 차등을 두지 않는다.
                            </li>
                            <li>
                              2) 회사는 능력과 업적에 대한 명확한 평가기준을
                              정립 및 공개하고 엄격히 준수함으로써 공정한 경쟁
                              풍토를 조성한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>3. 건전한 의사표시의 보장</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사는 임직원이 자유롭게 제안, 건의 및
                              애로사항을 표시할 수 있도록 필요한 제도를 갖추고
                              분위기를 조성한다.
                            </li>
                            <li>
                              2) 특정 종교나 정당을 위한 활동을 권유하거나
                              강요하지 않으며, 개인의 종교, 정치적 의사를
                              존중한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>4. 건강과 안전에 대한 책임</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사는 임직원의 건강과 업무 수행상의 안전을
                              위하여 필요하고도 적절한 조치를 취한다.
                            </li>
                            <li>
                              2) 특히 위험물, 유해물, 위해요인이 있는 작업장의
                              경우 반드시 필요한 안전조치를 취한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>5. 임직원의 삶의 질 향상</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사는 임직원이 자율적이고 창의적으로 일할 수
                              있도록 근무환경을 조성한다.
                            </li>
                            <li>
                              2) 회사는 모든 임직원들에게 자기개발과 역량향상을
                              위한 제반 활동을 적극 지원한다.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                    <li>
                      <h4>제 6 장 국가와 사회에 대한 책임</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 합리적인 사업 전개</h5>
                          <ol class="depth_03">
                            <li>
                              1) 회사는 사회의 윤리적 가치관을 존중하여
                              국민경제에 해를 끼치거나 위화감을 조성하는 행위를
                              하지 않으며 국민정서에 부합하는 사업을 전개한다.
                            </li>
                            <li>
                              2) 국내외를 막론하고 해당 지역의 사회적 가치관을
                              존중하며 사업을 수행한다.
                            </li>
                            <li>
                              3) 올바르고 합리적인 기업활동을 저해하는 모든
                              행위를 배제한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>2. 국가·사회 발전에 대한 공헌</h5>
                          <ol class="depth_03">
                            <li>
                              1) 학벌, 성별, 출신지역별 차별 없이 누구에게나
                              균등한 고용의 기회를 부여한다.
                            </li>
                            <li>2) 조세는 성실하게 신고하고 납부한다.</li>
                            <li>
                              3) 사회 가계 각층과 지역주민의 정당한 요구를
                              수용하며 이를 해결 하는데 최선을 다한다.
                            </li>
                            <li>
                              4) 임직원의 건전한 사회봉사활동 참여를 보장하고
                              권장한다.
                            </li>
                            <li>
                              5) 지속가능경영으로 사업활동의 체질을 끊임없이
                              개선하며 기업가치를 제고한다.
                            </li>
                            <li>
                              6) 기업경영 전반에 윤리성을 근간으로 비즈니스
                              파트너들과 상호 협력하고 동반성장 함으로써
                              국가발전에 이바지 한다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>3. 주주의 권리 및 이익 보호</h5>
                          <ol class="depth_03">
                            <li>
                              1) 주주의 알 권리와 정당한 요구, 제안, 공식적
                              결정을 존중한다.
                            </li>
                            <li>
                              2) 직무상 취득한 내부 또는 타기업의 정보를
                              이용하여 주식의 매매 등을 하지 않는다.
                            </li>
                            <li>
                              3) 대주주의 이익보호를 위하여 일방적으로
                              소액주주의 이익을 침해 하지 않는다.
                            </li>
                            <li>
                              4) 정확한 회계처리 및 공시를 통해 회계의 투명성을
                              확보한다.
                            </li>
                            <li>
                              5) 거래관행이 투명하지 않은 개인, 거래처, 국가와의
                              거래는 가급적 삼가고, 불법적인 허위, 변칙거래를
                              하지 않는다.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h5>4. 환경의 보호</h5>
                          <ol class="depth_03">
                            <li>
                              1) 환경보호에 위배되는 사업활동을 금지하며 공해 및
                              오염방지를 위한 적절한 투자를 한다.
                            </li>
                            <li>
                              2) 환경보호를 위해 적극적으로 환경보호 활동을
                              전개하며, 환경보호 관련 국제기준, 관계법령,
                              내부규정 등을 준수한다.
                            </li>
                            <li>
                              3) 제품의 개발, 생산, 유통, 판매 및 폐기의 모든
                              사업활동에서 환경 보호를 우선적으로 고려한다.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                  </ol>
                  <!--depth01-->
                </div>
              </div>
            </li>
            <!-- //윤리규범 -->
            <!-- 실천지침 -->
            <li :class="{ active: tabActs[1] }">
              <div class="tab_inner charter_txt">
                <div>
                  <ol class="depth_01">
                    <li>
                      <h4>제 1 장 총칙</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 목적</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              한국오션플랫폼㈜는 ‘한국오션플랫폼㈜ 윤리규범’의
                              실천을 강화하기 위하여 ‘한국오션플랫폼㈜ 윤리규범
                              실천지침’을 제정하여 전 임직원의 윤리적 의사결정
                              및 행동원칙으로 삼는다. 전 임직원은 회사업무를
                              수행함에 있어 ‘한국오션플랫폼㈜ 윤리규범
                              실천지침’을 철저하게 준수해야 한다. 본 자료는
                              ‘한국오션플랫폼㈜ 윤리규범 실천지침’의 시행과
                              관련하여 금품, 향응, 접대, 편의수수, 신고절차 등
                              필요한 제반 사항에 대해 구체적으로 규정함을
                              목적으로 한다.
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>2. 용어의 정의</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 임직원
                              <ul class="dash_sty">
                                <li>
                                  회사에 근로를 제공하는 대가로 임금을 지급받는
                                  일체의 임원 및 직원을 말하며, 회사와 업무의
                                  일부 또는 전부를 대행하는 계약을 체결한 경우
                                  그 사람도 사안에 따라 임직원으로 볼 수 있다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              2) 가족
                              <ul class="dash_sty">
                                <li>
                                  임직원의 배우자와 본인 및 배우자의 직계비속과
                                  4촌 이내의 친인척 관계에 있는 사람을 말한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              3) 직무
                              <ul class="dash_sty">
                                <li>
                                  직책이나 직급상 역할과 책임을 부여 받은
                                  업무로서 의사결정을 통해 이해관계자가 이익
                                  또는 손실이 발생할 가능성이 있는 경우를
                                  포함한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              4) 이해관계자
                              <ul class="dash_sty">
                                <li>
                                  업무와 관련한 임직원의 행위나 의사결정으로
                                  인해 그 권리와 이익에 영향을 받는 사내, 사외의
                                  모든 자연인, 법인, 기타 단체를 말한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              5) 금품
                              <ul class="dash_sty">
                                <li>
                                  현금, 수표, 상품권, 유가증권은 물론 부채상환,
                                  보증, 대출이자 대납, 동산 혹은 부동산의 무상,
                                  염가제공 등 일체의 금전적 혜택을 포함한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              6) 선물
                              <ul class="dash_sty">
                                <li>
                                  대가 없이 제공되는 물품, 회원권, 숙박권,
                                  입장권 및 이에 준하는 것을 의미한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              7) 기념품
                              <ul class="dash_sty">
                                <li>
                                  공식적인 행사에서 주최자가 참석자에게
                                  일률적으로 제공하거나, 불특정 다수인에게
                                  배포하기 위한 물품 또는 회사 로고가 기재되어
                                  있는 물품을 의미하며 경품 및 시상품을
                                  포함한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              8) 향응/ 접대
                              <ul class="dash_sty">
                                <li>
                                  식사, 음주, 스포츠(골프 등), 오락, 불건전업소
                                  등에서 발생한 비용을 부담하거나 부담시키는
                                  행위를 말한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              9) 편의제공
                              <ul class="dash_sty">
                                <li>
                                  금품, 향응접대 이외의 숙박 및 교통제공,
                                  관광안내, 각종 행사지원 등 수취인이 편의를
                                  누리기 위해 상대방에게 경제적인 손실을
                                  발생하게 하는 모든 경우를 말한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              10) 통상적 수준
                              <ul class="dash_sty">
                                <li>
                                  일반인이 건전한 상식으로 판단할 때 이해할 수
                                  있는 수준으로서 수혜자가 부담을 가지지 않고
                                  업무를 처리할 수 있는 정도를 의미한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              11) 이해관계의 상충
                              <ul class="dash_sty">
                                <li>
                                  회사의 업무를 효과적이고 공정하게 수행할 수
                                  있는 임직원의 능력이 외부의 임명, 관계 및 활동
                                  등에 의하여 잠재적 혹은 실제적으로 제약을 받는
                                  상황을 말한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              12) 협력회사
                              <ul class="dash_sty">
                                <li>
                                  한국오션플랫폼㈜ 내 모든 회사와 거래관계에
                                  있는 개인이나 법인을 말한다.
                                </li>
                              </ul>
                            </li>
                            <li>
                              13) 신고자
                              <ul class="dash_sty">
                                <li>
                                  금전 등의 수수 및 동 사실의 인지와 관련하여
                                  신고의무가 있는 모든 임직원을 말한다.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>3. 적용범위</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              본 지침은 한국오션플랫폼㈜ 내 모든 회사의 임직원
                              및 협력회사와 그 임직원에 대하여 적용된다.
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                    <li>
                      <h4>제 2 장 업무수행 기준</h4>
                      <!--depth02-->
                      <ol class="depth_02">
                        <li>
                          <h5>1. 이해관계자로부터 사례를 받는 행위</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 기본원칙
                              <ol class="depth_04">
                                <li>
                                  (1) 이해관계자에 의한 사례는 이유여하를
                                  불문하고 받아서는 안되며, 선물의 경우 정중하게
                                  거절하거나 되돌려 준다.
                                </li>
                                <li>
                                  (2) 이해관계자로부터 불가피하게 사례를 받았을
                                  경우 규정된 신고절차에 따라 반드시 신고를
                                  한다.
                                </li>
                                <li>
                                  (3) 회사 임직원 가족이라도 이해관계자로부터
                                  업무와 관련하여 제공된 것으로 생각되는 사례를
                                  받거나 요구하지 않는다.
                                </li>
                              </ol>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>2) 대상행위 및 판단기준</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              [금전수수] <sup>1)</sup>
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    금전수수 : 구분, 예시, 원칙, 비고로 이루어진
                                    표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">금전</th>
                                      <td>현금, 수표, 유가증권 등</td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">선물</th>
                                      <td>
                                        골프연습장 이용권, 헬스클럽 이용권,
                                        상품권, 관람권, 물품 등 기타 판촉 및
                                        할인혜택 포함
                                      </td>
                                      <td>금지</td>
                                      <td>
                                        원칙적으로 수수금지, 불가피한 경우
                                        5만원/회, 총액 10만원 이하<br />
                                        단, 판촉 및 할인혜택이 불특정 다수가
                                        대상인 경우는 허용
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="col">경조금</th>
                                      <td>
                                        경조금, 경조물품<br />(화환, 화분,
                                        돌반지 등)
                                      </td>
                                      <td>금지</td>
                                      <td>
                                        원칙적으로 수수금지<br />
                                        단, 불가피한 경우 5만원/회, 총액 10만원
                                        한도/년
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="col">협찬</th>
                                      <td>
                                        접대비, 회식비 및 기타 개인경비를
                                        이해관계자에게 전가하는 경우
                                      </td>
                                      <td>금지</td>
                                      <td>불가피한 경우 사후 환불</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <sup>1)</sup>유가증권을 포함한 금전 및 선물
                            </li>
                            <li>
                              [향응 및 접대]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    향응 및 접대 : 구분, 예시, 원칙, 비고로
                                    이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">식사</th>
                                      <td>
                                        이해관계자와의 식사 및 간단한 음주
                                      </td>
                                      <td>금지</td>
                                      <td>
                                        원칙적으로 수수금지<br />
                                        단, 불가피한 경우 한도내 에서 허용함<br />
                                        (5만원/인, 20만원/년)
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="col">불건전업소</th>
                                      <td>
                                        룸싸롱, 단란주점, 나이트클럽,
                                        안마시술소, 고급이발소, 고급사우나 등
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">오락</th>
                                      <td>고스톱, 내기골프 ,카지노, 카드</td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">스포츠</th>
                                      <td>골프, 스키</td>
                                      <td>금지</td>
                                      <td>
                                        회사에서 승인한 공식적 모임 외
                                        이해관계자와의 접대성 모임 금지
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                            <li>
                              [편의 제공]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    편의 제공 : 구분, 예시, 원칙, 비고로
                                    이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">출장지원</th>
                                      <td>
                                        교통편의(철도, 항공, 버스 승차권,
                                        차량지원 등) 및 숙식편의(숙박, 식사 등)
                                      </td>
                                      <td>적정대가지불</td>
                                      <td>
                                        업무효율을 위해 이해관계자가 제공하는
                                        편의를 이용하는 경우 반드시 정당한
                                        대가를 지불해야 함
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="col">개인휴가 지원</th>
                                      <td>
                                        개인적 휴가에 교통 및 숙박편의 제공,
                                        관광안내 등
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">
                                        사무실 이전비용 비품지원
                                      </th>
                                      <td>
                                        부서 이전비용 또는 사무용 비품(벽시계,
                                        거울 등) 지원
                                      </td>
                                      <td>금지</td>
                                      <td>
                                        원칙적 금지<br />
                                        단, 불가피한 경우 <br />
                                        선물범위 내에서 인정
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="col">협찬·찬조</th>
                                      <td>
                                        사내행사 등 협찬(금전, 물품, 교통편의
                                        등)/업무와 무관한 이해관계자의
                                        초청행사(국내/외 세미나 등)
                                      </td>
                                      <td>금지</td>
                                      <td>
                                        회사 사전승인 외 초청금지 및 이해관계자
                                        초청행사 <br />
                                        참여금지
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                            <li>
                              [차용(동산 및 부동산), 부채상환, 보증, 금전대차]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    차용(동산 및 부동산), 부채상환, 보증,
                                    금전대차 : 구분, 예시, 원칙, 비고로 이루어진
                                    표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col" rowspan="2">
                                        차용<br />
                                        염가매도<br />
                                        고가매도
                                      </th>
                                      <td>
                                        동산, 부동산 등 이해관계자의 자산을
                                        임차, 담보설정, 무상수수, 염가매입 등<br />임직원
                                        개인소유 자산의 고가 매도
                                      </td>
                                      <td rowspan="2">금지</td>
                                      <td rowspan="2">개인편의 및 영리 목적</td>
                                    </tr>
                                    <tr>
                                      <td>임직원 개인소유 자산의 고가 매도</td>
                                    </tr>
                                    <tr>
                                      <th scope="col">부채상환</th>
                                      <td>
                                        신용카드 대금, 외상대금, 대출금 등
                                        개인부채의 결제 또는 대리 상환
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">보증</th>
                                      <td>대출에 대한 보증 요구 /보증 제의</td>
                                      <td>금지</td>
                                      <td>금융기관 및 모든 형태의 대출 불문</td>
                                    </tr>
                                    <tr>
                                      <th scope="col">금전대차</th>
                                      <td>
                                        이해관계자와 금전을 빌리거나 빌려주는
                                        행위, 그에 따른 이자 지금 또는 수취 행위
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                            <li>
                              [미래에 대한 보장]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    [미래에 대한 보장] : 구분, 예시, 원칙,
                                    비고로 이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">고용알선</th>
                                      <td>
                                        이해관계자로부터 퇴직후 고용보장,
                                        취업알선 약속 등을 받는 행위
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">계약체결 약속</th>
                                      <td>
                                        퇴직후 사업거래 약속 체결 등을 하는 행위
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>2. 거래업체에 대한 부당지분 참여</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 기본원칙
                              <ol class="depth_04">
                                <li>
                                  (1) 이해관계가 있는 거래업체의 사장. 비상장
                                  증권에 대한 부당한 지분취득을 하지 않는다.
                                </li>
                                <li>
                                  (2) 이해관계자와의 공동투자 및 공동재산 획득은
                                  부당한 행위이며, 이를 위한하는 경우 실질지분
                                  소유관계에 근거하여 지분에 해당 하는 금액을
                                  이해관계자로부터 수취한 것으로 간주한다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              2) 대상행위 및 판단기준
                              <br />[주식수수 및 투자]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    [주식수수 및 투자] : 구분, 예시, 원칙,
                                    비고로 이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">상장주식</th>
                                      <td>
                                        회사와 거래관계에 있는 보유주식 전체
                                      </td>
                                      <td>
                                        회사의 원칙에 따라 정리 및 매매금지
                                      </td>
                                      <td>
                                        계열사, KOSPI200, KOSDAQ50에 포함된
                                        회사는 제외, 이외의 경우는 회사에
                                        영향력을 미칠 수 있는지에 따라 거래여부
                                        결정
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="col">비상장 주식</th>
                                      <td>
                                        회사와 거래관계에 있는 보유주식 전체
                                      </td>
                                      <td>즉각정리 및 매매 금지</td>
                                      <td>
                                        비상장주식은 어떤 경우에도 주식의 소유
                                        및 매매를 금지함
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              [공동투자 및 공동재산 취득]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    [공동투자 및 공동재산 취득] : 구분, 예시,
                                    원칙, 비고로 이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">
                                        공동투자<br />공동재산<br />취득
                                      </th>
                                      <td>
                                        자금의 공동투자를 통한 동산/부동산의
                                        취득(콘도,헬스클럽 등의 회원권, 부동산
                                        투자 등)
                                      </td>
                                      <td>금지</td>
                                      <td>신고 후 지분정리</td>
                                    </tr>
                                    <tr>
                                      <th scope="col">합작투자<br />사업</th>
                                      <td>
                                        자금의 공동투자, 명의 등재 등을 통한
                                        공동회사 보유 및 합작투자에 의한 사업
                                        영위
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">협력회사<br />겸직</th>
                                      <td>
                                        이해관계자의 회사에 이사 등재, 직원 겸직
                                        및 실질적 업무수행 행위
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>3. 협력업체와의 거래에 있어 투명성 유지</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 기본원칙
                              <ol class="depth_04">
                                <li>
                                  (1) 협력회사와의 거래에 있어 공정거래에 관한
                                  법률을 엄격히 준수한다.
                                </li>
                                <li>
                                  (2) 거래 공급업체는 공정하고 투명한 원칙에
                                  근거하여 공급자를 선정해야 한다. 이는 대량
                                  구매계약뿐만 아니라 간단한 서비스 계약까지를
                                  포함한 모든 거래에서 준수되어야 한다.
                                </li>
                                <li>
                                  (3) 거래관계에 있어 협력회사에 대해 거래조건에
                                  대한 제한 또는 조정이 필요한 경우 명백하고
                                  타당한 사유 및 투명한 절차에 의해 진행한다.
                                </li>
                                <li>
                                  (4) 거래상의 우월적 지위를 이용하여 불평등,
                                  부당한 대우, 불친절한 거래행위를 하지 않는다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              2) 대상행위 판단기준<br />[공정하지 않은 기회
                              부여]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    대상행위 판단기준 : 구분, 예시, 원칙, 비고로
                                    이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">거래거절</th>
                                      <td>
                                        정당한 사유 없이 거래참여 거절/기회 박탈
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">참여제한</th>
                                      <td>
                                        배타적인 거래조건 설정, 근거 없이
                                        거래지역 설정, 거래 상대방의 한정
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col" rowspan="2">차별</th>
                                      <td>
                                        가격/거래조건 차별, 담합을 통한 집단
                                        차별
                                      </td>
                                      <td rowspan="2">금지</td>
                                      <td rowspan="2"></td>
                                    </tr>
                                    <tr>
                                      <td>
                                        특정업체에 대하여 특혜 부여(높은 단가,
                                        거래조건 등)
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              [공정하지 않은 거래 행위]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    공정하지 않은 거래 행위 : 구분, 예시, 원칙,
                                    비고로 이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th rowspan="2" scope="col">부당거래</th>
                                      <td>
                                        일방적 납품물량 조절, 부당 염가 매입,
                                        계약조건의 일방적 변경, 대금결제의
                                        고의적 지연, 부당한 사유로 일방적 거래
                                        단절
                                      </td>
                                      <td rowspan="2">금지</td>
                                      <td rowspan="2">
                                        거래조건의 변경사유 발생시 협력회사와
                                        합의절차 준수
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>특정업체에 대해서 부당 고가 매입</td>
                                    </tr>
                                    <tr>
                                      <th scope="col">부당지원</th>
                                      <td>부당한 자금, 인력, 자산 지원</td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th scope="col">사업방해</th>
                                      <td>
                                        부당한 기술 이용, 협력회사 인력의 부당
                                        채용, 경쟁업체와의 거래 방해, 기타
                                        사업활동 방해
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              [협력업체 정보유출 행위]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    협력업체 정보유출 행위 : 구분, 예시, 원칙,
                                    비고로 이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col">정보유출</th>
                                      <td>
                                        협력업체로부터 획득한 제반 정보의 외부
                                        유출
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>4. 회사자산의 불법·부당한 사용</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 기본원칙
                              <ol class="depth_04">
                                <li>
                                  (1) 회사의 유·무형자산 및 기밀정보 등은 회사의
                                  중요한 자산으로 회사의 사업활동 및 승인된
                                  목적으로만 사용되어야 한다.
                                </li>
                                <li>
                                  (2) 회사의 비용은 공금으로 건전한 기업활동을
                                  위해 사용되어야 한다. 따라서 정해진 목적에
                                  맞게 사용되어야 한다.
                                </li>
                              </ol>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>2) 대상행위 및 판단기준</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              [유·무형자산의 타용도 사용]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    [유·무형자산의 타용도 사용] : 구분, 예시,
                                    원칙, 비고로 이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col" rowspan="3">
                                        유형자산<br />
                                        횡령·유용
                                      </th>
                                      <td>
                                        고정자산:토지,건물,설비기기 등
                                        유형고정자산을 사업목적 외
                                        전용/무단사용, 개인 영리목적 이용
                                      </td>
                                      <td rowspan="3">금지</td>
                                      <td rowspan="3"></td>
                                    </tr>
                                    <tr>
                                      <td>
                                        업무용자산: 차량,PC,고가의 소모품,
                                        사무용품 등 업무용자산을 무단반출/사용,
                                        가족/친지 제공, 유지비용 전가 등
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        법인카드: 한도를 초과한 과다사용,
                                        비용계정의 전용, 개인용도 사용 등
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="col">무형자산 유용</th>
                                      <td>
                                        제품 설계도의 유출, 영업기밀/사업정보
                                        유출 등을 통한 자신의 이익 목적에 사용
                                        또는 경쟁업체에 제공
                                      </td>
                                      <td>금지</td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              [공금횡령 및 유용]
                              <div class="tbl_doc">
                                <table>
                                  <caption>
                                    [공금횡령 및 유용] : 구분, 예시, 원칙,
                                    비고로 이루어진 표
                                  </caption>
                                  <thead>
                                    <tr>
                                      <th scope="row">구분</th>
                                      <th scope="row">예시</th>
                                      <th scope="row">원칙</th>
                                      <th scope="row">비고</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="col" rowspan="2">
                                        공금횡령 및 유용
                                      </th>
                                      <td>
                                        회사공금의 무단인출, 사적인 융통,
                                        회계장부 조작 등을 통한 개인 착복,
                                        이해관계자에 증여
                                      </td>
                                      <td rowspan="2">금지</td>
                                      <td rowspan="2"></td>
                                    </tr>
                                    <tr>
                                      <td>
                                        법인카드 불법전용(카드 깡 등), 허위
                                        영수증을 통한 비용처리(개인사용 영수증
                                        등), 무증빙제도의 악용, 개인 유흥 또는
                                        회계처리가 어려운 접대성 경비 등을 타
                                        계정의 비용으로 합산 처리, 회사
                                        법인카드를 가족/친지에게 제공하여 무단
                                        사용, 기타 회사 경비처리 기준에 반하는
                                        사적인 집행
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>5. 문서의 계수조각 및 허위보고</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 기본원칙
                              <ol class="depth_04">
                                <li>
                                  (1) 모든 정보의 기록과 보고는 정확하고
                                  정직해야 한다.
                                </li>
                                <li>
                                  (2) 임직원의 고의 또는 부주의로 인한 사실과
                                  다른 문서, 계수의 조작은 상급관리자나
                                  관련부서의 인사결정 및 판단을 흐리게 하거나
                                  오판하게 할 수 있음을 인식하고 주의해야 한다.
                                </li>
                                <li>
                                  (3) 특히, 결산을 포함한 모든 회계문서는 세법과
                                  기업회계기준에 따라 공정하게 작성하여 주주 등
                                  이해관계자에게 보고해야 한다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              2) 대상행위 및 판단기준
                              <ol class="depth_04">
                                <li>
                                  (1) 문서의 계수조작
                                  <ol class="depth_05">
                                    <li>
                                      ① 임직원이 정보를 기록하고 회사에 제출하는
                                      일정한 종류의 모든 문서 및 계수는 정확하고
                                      정직하게 작성한다.
                                    </li>
                                    <li>
                                      ② 상급관리자가 문서 또는 계수에 대한
                                      조작을 지시하거나, 혹은 하급자가 이런
                                      지시가 명백하게 부정한 행위임을 알고도
                                      용인하는 것은 동일한 불법행위로 처벌을
                                      받는다.
                                    </li>
                                  </ol>
                                </li>
                                <li>
                                  (2) 허위보고
                                  <ol class="depth_05">
                                    <li>
                                      ① 회사내의 경영진이나 인사총무팀 또는 회사
                                      외부의 조직이나 사람들에게 부정직한
                                      허위보고를 하는 것은 불법행위로 판단하여
                                      엄격하게 금지한다.
                                    </li>
                                    <li>
                                      ② 고객에게 상품을 판매하거나 서비스를
                                      제공하는 경우에 허위 진술을 하는 경우도
                                      부정행위로 간주한다.
                                    </li>
                                    <li>
                                      ③ 직접적인 허위보고 이외에도 정보 수령자의
                                      오해를 꾀하려는 목적의 정보조작 역시
                                      동일한 부정행위로 간주한다.
                                    </li>
                                  </ol>
                                </li>
                              </ol>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>6. 직장내 성희롱 방지</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 기본원칙<br />직장내 성희롱은 피해자에게
                              근무의욕의 상실, 업무 생산성 저하를 가져오며, 결국
                              회사에 기업 이미지 손상, 법적 소송 등의 부담을
                              가져올 수 있기 때문에 철저히 예방을 해야 한다.
                              <ul class="depth_04">
                                <li>
                                  (1) 음담패설을 삼가고 회식 때 술시중이나 춤을
                                  강요하지 않는다.
                                </li>
                                <li>
                                  (2) 직장에서 음란한 인터넷 사이트나 동영상,
                                  사진을 보지 않는다.
                                </li>
                                <li>
                                  (3) 직장 동료의 신체에 대해 성적인 평가나
                                  비유를 하지 않는다.
                                </li>
                                <li>
                                  (4) 불필요한 신체접촉을 삼가고 고정된 성
                                  역할을 강조하는 말(여자 또는 남자이기
                                  때문에)을 하지 않는다.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>7. 포상 및 징계, 예외사항의 해석</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 포상 및 징계
                              <ol class="depth_04">
                                <li>
                                  (1) 회사는 윤리경영 실천에 공로가 있는
                                  임직원에게 관련 규정에 따라 포상 또는 적정한
                                  보상금을 지급할 수 있다.
                                </li>
                                <li>
                                  (2) 회사는 윤리규범을 위반한 임직원에 대해서
                                  사규에 따라 처벌할 수 있다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              2) 예외사항의 해석
                              <ol class="depth_04">
                                <li>
                                  (1) 윤리규범에 구체적으로 수록되어 있지 않거나
                                  해석상에 분쟁의 소지가 발생한 경우에는
                                  인사총무팀에 문의하여 그 해석에 따른다.
                                </li>
                              </ol>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>8. 윤리경영 위반사항의 신고</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              1) 기본원칙
                              <ol class="depth_04">
                                <li>
                                  (1) 임직원은 윤리규범 위반사항을 인지한 때
                                  또는 제 3자로부터 그러한 상황을 접수한 때는
                                  반드시 회사에 보고를 해야 하며, 회사는 신고를
                                  접수할 수 있는 ‘사이버신문고’를 인사총무팀
                                  주관으로 사내홈페이지 및 외부홈페이지에
                                  설치하여 운영해야 한다.
                                </li>
                                <li>
                                  (2) 회사는 내부 비리 신고자에 대해서는 비밀을
                                  유지해야 하며, 인사상 불이익을 주는 행위를
                                  해서는 안된다.
                                </li>
                                <li>
                                  (3) 내부비리 신고자에 대해 그 사실을 이유로
                                  보복행위를 하는 자는 사내규정이 정하는
                                  범위내에서 가중처벌을 할 수도 있다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              2) 신고의무
                              <ol class="depth_04">
                                <li>
                                  (1) 임직원은 본인 또는 타인의 윤리규범 및
                                  지침의 위반사항을 인지한 즉시 윤리경영
                                  주관부서인 인사총무팀에 신고를 해야 한다.
                                </li>
                                <li>
                                  (2) 임직원은 이해관계가 발생하였거나,
                                  이해관계가 발생할 우려가 있는 경우에도 신고를
                                  해야 한다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              3) 위반에 대한 징계
                              <ol class="depth_04">
                                <li>
                                  (1) 임직원은 윤리규범 및 본 지침을 위반하거나
                                  타인의 위반 사실을 묵인 또는 방조한 경우
                                  징계의 대상이 된다.
                                </li>
                                <li>
                                  (2) 윤리규범 및 본 지침을 위반한 임직원이 그
                                  사실을 자진 신고한 경우에 회사는 정상참작을
                                  하여 징계를 경감해 줄 수 있다.
                                </li>
                                <li>
                                  (3) 징계에 대한 사항은 별도의 사규에 따라
                                  시행한다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              4) 제보자의 보호
                              <ol class="depth_04">
                                <li>
                                  (1) 윤리경영 위반에 관한 제보자 및 제보관련
                                  참고 진술자의 노출을 원칙적으로 금지한다.
                                </li>
                                <li>
                                  (2) 제보자 및 제보관련 참고 진술자의 신원을
                                  인지한 임직원은 신분의 비밀을 보장해야 하며,
                                  제보자 및 제보관련 참고 진술자에게 어떠한
                                  불이익을 주어서도 안된다.
                                </li>
                                <li>
                                  (3) 신분노출, 차별대우 등 불이익을 받은
                                  제보관련 참고 진술자는 인사총무팀에 보호조치나
                                  구제를 신청할 수 있으며, 인사총무팀은 제보자
                                  및 제보관련 참고 진술자에게 필요하다고
                                  판단되는 적절한 조치를 취해야 한다.
                                </li>
                                <li>
                                  (4) 제보자의 신분이 노출된 경우 인사총무팀은
                                  신분노출 경로에 대해 조사를 하고, 고의 또는
                                  과실로 제보자의 신분을 노출한 임직원은 징계의
                                  대상이 될 수 있다.
                                </li>
                              </ol>
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                        <li>
                          <h5>9. 윤리교육의 수립 및 실시 등</h5>
                          <!--depth03-->
                          <ol class="depth_03">
                            <li>
                              (1) 교육 운영 일정
                              <ol class="depth_04">
                                <li>① 계획 수립: 매년 초 교육 계획 수립</li>
                                <li>
                                  ② 교육 이수 기간: 연단위로 운영 (매년 01.01 ~
                                  12.31)
                                </li>
                                <li>
                                  ③ 세부 교육일정: 회사의 연간 교육 일정을
                                  고려하여 해당 교육일정 수립, 교육 프로그램에
                                  따라 연간 최소 1회 이상 실시
                                </li>
                              </ol>
                            </li>
                            <li>
                              (2) 교육 진행 방법: 교육 대상 및 교육 프로그램별
                              적합한 교육 진행 방법의 선택
                              <ol class="depth_04">
                                <li>① 진행 방식: 집합 교육 또는 온라인 교육</li>
                                <li>② 교육 장소: 사내 또는 사외</li>
                                <li>③ 교육 주기: 정기 또는 비정기</li>
                              </ol>
                            </li>
                            <li>
                              (3) 교육 프로그램은 일반윤리 및 준법교육을
                              포함하며 교육 대상자별 의무 이수 교육시간을
                              고려하여 해당 교육 프로그램을 구성하여야 한다.
                              프로그램은 교육 주체에 따라 사내 및 사외
                              프로그램으로 구분될 수 있으며, 사내 및 사외
                              프로그램 운영에 있어 고려되어야 할 사항은 다음과
                              같다.
                              <ol class="depth_04">
                                <li>
                                  ① 사내 교육 프로그램 운영
                                  <ul class="dot_lst">
                                    <li>
                                      사내 교육 프로그램 운영 시, 세부 교육 내용
                                      개발, 학습자료(교재) 개발, 평가방법 및
                                      도구개발 등
                                    </li>
                                    <li>
                                      교육 주제와 관련하여 전문지식을 지닌
                                      임직원 및 외부인사등을 초청하여 교육
                                      프로그램 구성
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  ② 사외 교육 프로그램 이용
                                  <ul class="dot_lst">
                                    <li>
                                      외부 교육기관에서 개설되어 있는 윤리 또는
                                      준법 관련 교육으로 구성
                                    </li>
                                    <li>
                                      외부 교육 이수 후, 참여 인원이 작성한 교육
                                      결과 보고서 또는 외부 교육기관의
                                      수료증·성적표 등의 증빙서류를 통해 교육
                                      이수를 확인하고 교육 이수 이력을 관리
                                    </li>
                                  </ul>
                                </li>
                              </ol>
                            </li>
                            <li>
                              (4) 인사정책과의 연계
                              <ol class="depth_04">
                                <li>
                                  ① 교육 의무 이수제의 운영을 통해 교육대상
                                  임직원의 교육 이수 사항은 성과평가, 인센티브
                                  및 보상 정책에 반영한다.
                                </li>
                                <li>
                                  ② 교육이수 사항의 성과평가, 인센티브 및 보상
                                  정책 평가 반영 비율은 인사부서가 결정하여
                                  성과평가에 반영한다.
                                </li>
                              </ol>
                            </li>
                            <li>
                              (5) 현장교육(온라인교육 포함)을 원칙으로 하나
                              불가능한 경우(지방 및 해외지사) 관련 교육 자료를
                              전달하는 방식으로 진행한다.
                            </li>
                            <li>
                              (6) 참석하지 않은 인원에 대해 소속 팀장의 승인을
                              득한 사유서 등을 제출하고 재교육 및 부서성과평가
                              등에 반영하고 있다.
                            </li>
                            <li>
                              (7) 윤리규범의 교육 수행 결과는 대표이사에게
                              보고한다.
                            </li>
                          </ol>
                          <!--//depth03-->
                        </li>
                      </ol>
                      <!--//depth02-->
                    </li>
                  </ol>
                  <!--depth01-->
                </div>
              </div>
            </li>
            <!-- //실천지침 -->
          </ul>
        </div>
      </div>
    </div>

    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page],
  data() {
    return {
      tabActs: Array.from({ length: 2 }).map((item, idx) => idx === 0)
    };
  },
  mounted() {
    this.initTween();
  },
  methods: {
    changeTab({ acts }) {
      this.tabActs = acts;
    }
  }
};
</script>

<style lang="scss" scoped></style>
